(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.browse = skyward.browse || {};

        const allBrowseStats = [];
        let refreshTimeout = null;
        const deselectPreviousRecordOverrides = {};
        const eventCallbacks =
        {
            updateActiveBrowseClasses: skyward.events.getCallbackStore(),
            recordSelectionMade: skyward.events.getCallbackStore(),
        };
        const defaultUpdateCurrentRecordSettings =
        {
            loadRelatedBrowses: true,
            updateBrowseSeekInfo: true,
            setCurrentBrowseName: false
        };

        const classNames =
        {
            browse: "browse",
            current: "current",
            selectedDetailsRow: "selectedDetailsRow",
            browseDataCell: "browseDataCell",
            browseRow: "browseRow",
            browseRowContent: "browseRowContent",
            mainSelectedBrowse: "mainSelectedBrowse",
            browseRowMenus: "browseRowMenus",
            button: "button",
            modalLayerContainer: "modalLayerContainer",
            isInDetailsPanel: "js-isInDetailsPanel",
            browseBody: "browseBody",
            unlockedBrowseBody: "unlockedBrowseBody",
            lockedBrowseBody: "lockedBrowseBody"
        };
        const valueNames =
        {
            detailsPanelIdentifier: "browse"
        };
        const mobileBrowseClasses =
        {
            mobileBrowseContainer: "mobileBrowseContainer",
            mobileBrowseBody: "mobileBrowseBody",
            hasHeaderShadow: "hasHeaderShadow",
            hasColumnShadow: "hasColumnShadow",
            lockedColumnCell: "lockedColumnCell"
        };
        const addKeyUpHandler = (function ()
        {
            var keyUpListeners = {};

            var sharedKeyUpHandler = function (event)
            {
                var listener = keyUpListeners[event.which];
                if (!listener)
                {
                    return;
                }
                delete keyUpListeners[event.which];
                if ($.isEmptyObject(keyUpListeners))
                {
                    $(document.documentElement).off("keyup", sharedKeyUpHandler);
                }
                return listener.call(this, event);
            };

            return function (keyCode, expectedBrowseName)
            {
                if (keyUpListeners[keyCode])
                {
                    return;
                }
                if ($.isEmptyObject(keyUpListeners))
                {
                    $(document.documentElement).on("keyup", sharedKeyUpHandler);
                }
                keyUpListeners[keyCode] = keyUpListener;

                function keyUpListener(event)
                {
                    var browse = getCurrentBrowse();
                    if (!browse || browse.id !== expectedBrowseName)
                    {
                        return;
                    }
                    else if (browse.primaryKeys.length > 1)
                    {
                        rowChange(browse.id, browse.currentRow, true);
                    }
                    event.stopPropagation();
                }
            };
        })();
        const browseDetailsPanel = (function ()
        {
            var currentDetailsBrowse = null; // the name of the browse that is open in the detailsPanel
            var browseDetailsPanel =
            {
                get currentDetailsBrowse()
                {
                    return currentDetailsBrowse;
                },
                set currentDetailsBrowse(value)
                {
                    currentDetailsBrowse = skyward.browse.browseList.hasOwnProperty(value) ? value : null;
                },
            };

            browseDetailsPanel.detailsPanelTypes =
            {
                cell: "cell",
                row: "row"
            };

            browseDetailsPanel.getSelectedRow = function (getAllRows)
            {
                if (getAllRows)
                {
                    return $(classNames.selectedDetailsRow.dot());
                }

                return $(classNames.unlockedBrowseBody.dot()).find(classNames.selectedDetailsRow.dot());
            };

            browseDetailsPanel.setSelectedRow = function (browseName)
            {
                browseDetailsPanel.resetSelectedRow();
                var browse = getBrowseByName(browseName);
                if (browse)
                {
                    getRowElements(browse).addClass(classNames.selectedDetailsRow);
                }
            };

            browseDetailsPanel.resetSelectedRow = function ()
            {
                browseDetailsPanel.getSelectedRow(true).removeClass(classNames.selectedDetailsRow);
            };

            browseDetailsPanel.init = function ()
            {
                skyward.detailsPanel.eventCallbacks.open.registerCallback(function (_data, additionalData)
                {
                    var browseName = additionalData.browseName;
                    browseDetailsPanel.currentDetailsBrowse = browseName;
                    browseDetailsPanel.setSelectedRow(browseDetailsPanel.currentDetailsBrowse);
                });

                skyward.detailsPanel.eventCallbacks.close.registerCallback(function (_data, _additionalData)
                {
                    var currentBrowseName = skyward.browse.getCurrentBrowseName();
                    browseDetailsPanel.currentDetailsBrowse = null;
                    browseDetailsPanel.resetSelectedRow();
                    if (shouldShowDetailsPanelForBrowse(currentBrowseName))
                    {
                        // If we are reopening a details panel after closing another, add a delay.
                        // It is jarring to have one panel close and other instantly reopen
                        window.setTimeout(function ()
                        {
                            browseDetailsPanel.showDetailsPanel(currentBrowseName, true);
                        }, 500);
                    }
                });

                skyward.detailsPanel.eventCallbacks.empty.registerCallback(function (_data)
                {
                    browseDetailsPanel.resetSelectedRow();
                    removeDetailsPanelBrowsesFromOpenBrowses();
                });

                skyward.detailsPanel.eventCallbacks.resizeClose.registerCallback(function (_data)
                {
                    browseDetailsPanel.currentDetailsBrowse = null;
                    browseDetailsPanel.resetSelectedRow();
                });

                skyward.detailsPanel.eventCallbacks.resizeOpen.registerCallback(function (_data, additionalData)
                {
                    if (additionalData.identifier !== valueNames.detailsPanelIdentifier)
                    {
                        return;
                    }
                    var browseName = additionalData.browseName;
                    var primaryKey = additionalData.primaryKey;
                    var browseIsStillValid = skyward.browse.browseList.hasOwnProperty(browseName);
                    var currentBrowseName = skyward.browse.getCurrentBrowseName();
                    var isSameBrowse = browseIsStillValid && browseName === currentBrowseName;
                    var isSameRow = isSameBrowse && getCurrentRecordTargetId(browseName) === primaryKey;

                    if (isSameRow)
                    {
                        // The record hasn't changed, so the previously opened details panel will be reused 
                        // (it is already visible when this event is triggered)
                        browseDetailsPanel.currentDetailsBrowse = browseName;
                        browseDetailsPanel.setSelectedRow(browseName);
                    }
                    else if (shouldShowDetailsPanelForBrowse(currentBrowseName))
                    {
                        // the previous details panel is no longer valid.  Open a new panel for the current browse if it allows it.
                        browseDetailsPanel.showDetailsPanel(currentBrowseName, false);
                    }
                });

                skyward.detailsPanel.eventCallbacks.contentLoaded.registerCallback(function (_data, additionalData)
                {
                    var browseName = additionalData.browseName;
                    browseDetailsPanel.currentDetailsBrowse = browseName;
                    browseDetailsPanel.setSelectedRow(browseName);
                });

                skyward.detailsPanel.eventCallbacks.resizeCanOpen.registerCallback(function ()
                {
                    var browse = getCurrentBrowse();
                    if (browse && shouldShowDetailsPanelForBrowse(browse.id))
                    {
                        if (browse.isRegistered === true)
                        {
                            browseDetailsPanel.showDetailsPanel(browse.id, false);
                        }
                        else
                        {
                            // finishRegistration() will call tryRefreshDetailsPanel and show the details panel
                            browseDetailsPanel.currentDetailsBrowse = browse.id;
                        }
                    }
                });
            };

            browseDetailsPanel.showDetailsPanel = function (browseName, shouldAnimate)
            {
                var browse = getBrowseByName(browseName);
                if (!browse || !shouldShowDetailsPanelForBrowse(browseName))
                {
                    return $.Deferred().reject();
                }

                var currentRecordID = getCurrentRecordTargetId(browseName);

                if (!(browse.rowModule && browse.rowObject && browse.rowScreen && currentRecordID != null))
                {
                    return $.Deferred().reject();
                }

                var elementData = getUnlockedRowElement(browse).data();

                skyward.browse.setCurrentBrowseName(browseName);

                var module = elementData.rowmodule;
                var object = elementData.rowobject;
                var screen = elementData.rowscreen;
                var postData = getDetailsPanelPostData(browse);

                // Clear Confirmation Message data, it is only needed once per details panel
                browse.confirmationMessage = null;
                browse.confirmationMessageContainer = null;

                var detailsPanelOptions =
                {
                    shouldAnimate: shouldAnimate,
                    panelWidth: elementData.panelwidth,
                    additionalData:
                    {
                        identifier: valueNames.detailsPanelIdentifier,
                        browseName: browseName,
                        primaryKey: currentRecordID
                    }
                };

                browseDetailsPanel.currentDetailsBrowse = browseName;

                return skyward.detailsPanel.openDetailsPanel(module, object, screen, currentRecordID, postData, detailsPanelOptions).fail(function ()
                {
                    browseDetailsPanel.currentDetailsBrowse = null;
                });
            };

            browseDetailsPanel.hideDetailsPanel = function (shouldAnimate)
            {
                return skyward.detailsPanel.closeDetailsPanel(shouldAnimate);
            };

            browseDetailsPanel.toggleDetailsPanel = function (browseName, shouldAnimate)
            {
                var isOpen = skyward.detailsPanel.isDetailsPanelOpen();
                skyward.detailsPanel.setDetailsPanelSessionState(!isOpen);
                var deferred = $.Deferred();
                if (isOpen)
                {
                    skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                    {
                        if (wasDirty)
                        {
                            browseDetailsPanel.hideDetailsPanel(shouldAnimate).then(deferred.resolve, deferred.reject);
                        }
                        else
                        {
                            deferred = browseDetailsPanel.hideDetailsPanel(shouldAnimate);
                        }
                    });
                }
                else
                {
                    deferred = browseDetailsPanel.showDetailsPanel(browseName, shouldAnimate);
                }

                deferred.fail(function ()
                {
                    skyward.detailsPanel.setDetailsPanelSessionState(isOpen);
                });
                return deferred;
            };

            browseDetailsPanel.tryRefreshDetailsPanel = function (browseName)
            {
                const browse = getBrowseByName(browseName);

                if (browse === undefined || browse.detailsPanelType !== browseDetailsPanel.detailsPanelTypes.row)
                {
                    return;
                }

                const detailsPanelIsSet = !!browseDetailsPanel.currentDetailsBrowse;
                const isMainBrowse = browse.browse.hasClass(classNames.mainSelectedBrowse);
                const currentBrowseName = skyward.browse.getCurrentBrowseName();
                const isCurrentDetailsPanelBrowse = browseName === browseDetailsPanel.currentDetailsBrowse && (browseName === currentBrowseName || currentBrowseName === null /* might be behind a workflow */);

                if (isMainBrowse && !detailsPanelIsSet || isCurrentDetailsPanelBrowse)
                {
                    browseDetailsPanel.refreshDetailsPanel(browseName);
                }
            };

            browseDetailsPanel.refreshDetailsPanel = function (browseName)
            {
                var shouldAnimate = false;
                if (shouldShowDetailsPanelForBrowse(browseName))
                {
                    browseDetailsPanel.showDetailsPanel(browseName, shouldAnimate);
                }
                else
                {
                    browseDetailsPanel.hideDetailsPanel(shouldAnimate);
                }
            };

            browseDetailsPanel.tryRowChange = function (browseName, doChangeRowCallback, shouldShowDetailsPanel)
            {
                if (!shouldShowDetailsPanelForBrowse(browseName))
                {
                    if (shouldHideDetailsPanelForBrowse(browseName))
                    {
                        skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                        {
                            browseDetailsPanel.hideDetailsPanel(true);
                            doChangeRowCallback();
                        });
                    }
                    else
                    {
                        doChangeRowCallback();
                    }
                    return;
                }

                skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                {
                    if (wasDirty === true)
                    {
                        changeRowAndShowDetailsPanel();
                    }
                    else if (skyward.detailsPanel.getDetailsPanelSessionState())
                    {
                        changeRowAndShowDetailsPanel();
                    }
                    else
                    {
                        doChangeRowCallback();
                    }
                });

                function changeRowAndShowDetailsPanel()
                {
                    doChangeRowCallback();
                    if (shouldShowDetailsPanel)
                    {
                        browseDetailsPanel.showDetailsPanel(browseName);
                    }
                }
            };

            browseDetailsPanel.detailsPanelSaveUpdateRow = function (data)
            {
                var browse = getBrowseByName(browseDetailsPanel.currentDetailsBrowse);
                if (browse === undefined)
                {
                    return;
                }
                var postData = $.extend({}, getDetailsPanelPostData(browse), data);
                return skyward.browse.get(browseDetailsPanel.currentDetailsBrowse, { seekId: browse.primaryKeys[browse.currentRow] }, postData);
            };

            browseDetailsPanel.setDetailsPanelTabData = function (tabData)
            {
                var browse = getBrowseByName(browseDetailsPanel.currentDetailsBrowse);
                if (browse === undefined)
                {
                    return;
                }
                browse.tabData = tabData;
            };

            return browseDetailsPanel;

            /**
             * Checks if the browse for the browse name provided should allow row-level details panels to be opened.
             * @param {string} browseName - The name of the browse to check.
             * @returns {boolean} True if the browse should allow row-level details panels to be opened.
             */
            function shouldShowDetailsPanelForBrowse(browseName)
            {
                var browse = getBrowseByName(browseName);
                if (browse === undefined)
                {
                    return false;
                }
                //if any of these conditions are true the detailsPanel can't be displayed
                var conditionsToNotShowDetailsPanel =
                    [
                        browse.hidePreviewDetailsButton, //details button is hidden for the browse
                        skyward.browse.isInWorkflow(browse), 
                        browse.isInDetailsPanel,
                        skyward.modalLayer.elementIsInModalLayer(browse.browse),
                        !skyward.detailsPanel.getDetailsPanelSessionState(), // details panel session state is Closed
                        !skyward.detailsPanel.canShowDetailsPanel(), // window is too small to show details panel,
                        browse.detailsPanelType !== browseDetailsPanel.detailsPanelTypes.row,
                        !(browse.rowModule && browse.rowObject && browse.rowScreen)
                    ];

                return !conditionsToNotShowDetailsPanel.includes(true);
            }

            /**
             * Checks if the browse for the browse name provided should automatically 
             * close an open details panel when it becomes the active browse.
             * @param {string} browseName - The name of the browse to check.
             * @returns {boolean} True if the browse should automatically close an open details panel when it becomes the active browse.
             */
            function shouldHideDetailsPanelForBrowse(browseName)
            {
                var browse = getBrowseByName(browseName);
                if (browse === undefined)
                {
                    return false;
                }
                var detailsPanelData = skyward.detailsPanel.getData();
                // if any of these conditions are true the detailsPanel can't be closed
                var conditionsToNotHideDetailsPanel =
                    [
                        skyward.browse.isInWorkflow(browse),
                        browse.isInDetailsPanel,
                        skyward.modalLayer.elementIsInModalLayer(browse.browse),
                        // the details panel has it's own close button, the browse shouldn't close it automatically
                        !$.isEmptyObject(detailsPanelData) && !$.isEmptyObject(detailsPanelData.options) && detailsPanelData.options.useCloseButton === true
                    ];

                return !conditionsToNotHideDetailsPanel.includes(true);
            }

            function removeDetailsPanelBrowsesFromOpenBrowses()
            {
                skyward.browse.openBrowses = skyward.browse.openBrowses.filter(function (browseName)
                {
                    return browseName.indexOf("detailsPanel_") !== 0;
                });
            }

            function getDetailsPanelPostData(browse)
            {
                var data =
                {
                    renderInDetailsPanel: true,
                    confirmationMessage: browse.confirmationMessage,
                    confirmationMessageContainer: browse.confirmationMessageContainer
                };

                var currentRow = getUnlockedRowElement(browse);

                if (currentRow.length > 0)
                {
                    $.extend(data, currentRow.data("postdata"));
                }

                if (browse.tabData && browse.tabData.tabType === "details")
                {
                    data.tab = browse.tabData.tab;
                }
                return data;
            }
        })();
        var throttledRowClick = (function ()
        {
            var rateLimit = 10; //ms
            var timeOutHandler;
            return function ()
            {
                if (timeOutHandler)
                {
                    return;
                }
                rowClick.apply(this, arguments);
                timeOutHandler = window.setTimeout(function ()
                {
                    timeOutHandler = null;
                }, rateLimit);
            };
        })();

        // The last element in the array should always contain the browse name that should receive keypresses.
        // This array is only for this purpose.
        skyward.browse.openBrowses = [];
        skyward.browse.minColumnWidth = 65;
        skyward.browse.maxColumnWidth = 999;
        skyward.browse.eventCallbacks = skyward.events.getCallbackStoreFacadeCollection(eventCallbacks);
        skyward.browse.browseList = {};
        skyward.browse.resizeBrowseList = function ()
        {
            for (var browse in skyward.browse.browseList)
            {
                try
                {
                    if (skyward.browse.browseList[browse].resize)
                    {
                        skyward.browse.browseList[browse].resize();
                    }
                }
                catch (_err)
                {
                    delete skyward.browse.browseList[browse];
                }
            }
        };

        skyward.browse.isInWorkflow = function (browse)
        {
            return !!browse.taskName;
        }

        skyward.browse.detailsPanelSaveUpdateRow = browseDetailsPanel.detailsPanelSaveUpdateRow;

        skyward.browse.tryRefreshDetailsPanel = browseDetailsPanel.tryRefreshDetailsPanel;

        skyward.browse.setDetailsPanelTabData = function (tabData)
        {
            browseDetailsPanel.setDetailsPanelTabData(tabData);
        };

        skyward.browse.getCurrentRowElement = function (rowType, browseName, rowNumber, browseType)
        {
            if (browseType === "Tile")
            {
                return $("#" + browseName + "_" + "Tile" + rowNumber);
            }
            else if (browseType === "DistinctMultiSelect" && rowNumber === -1)
            {
                return $("#" + browseName + "_" + rowType + "Header").find(".js-massSelectCell");
            }
            else
            {
                //rowType should be "unlocked" or "locked"
                return $("#" + browseName + "_" + rowType + "Row" + rowNumber);
            }
        };

        skyward.browse.registerDeselectPreviousRecordOverrideListener = function (browseName, callback)
        {
            deselectPreviousRecordOverrides[browseName] = callback;
        };

        skyward.browse.deregisterDeselectPreviousRecordOverrideListener = function (browseName)
        {
            delete deselectPreviousRecordOverrides[browseName];
        };

        skyward.browse.setCurrentRecord = function (browseName, row, options)
        {
            var browse = getBrowseByName(browseName);
            // browse.currentRow may be undefined for Gradebook.  We want to invalidate in that case.
            var isBrowseValid = !$.isEmptyObject(browse) && browse.currentRow !== undefined;
            // DMSE is allowed to have a negative row number 
            var isRowValid = isBrowseValid && !isNaN(parseInt(row)) && (row >= 0 || browse.browseType === "DistinctMultiSelect");

            if (!isRowValid)
            {
                return;
            }

            var settings = $.extend({}, defaultUpdateCurrentRecordSettings, options);
            var recordChanged = row != browse.currentRow;
            var lockedRow = getLockedRowElement(browse, row);
            var unlockedRow = getUnlockedRowElement(browse, row);
            var unlockedBody = $("#" + browseName + "_unlockedBody");

            if (unlockedBody.length > 0 && unlockedRow.length > 0)
            {
                var bodyTop = unlockedBody.scrollTop();
                var bodyBottom = bodyTop + unlockedBody.height();
                var rowTop = unlockedRow.offset().top - unlockedBody.offset().top + bodyTop;
                var rowBottom = rowTop + unlockedRow.height();

                var scrollRowIntoView = function (alignToTop)
                {
                    unlockedRow[0].scrollIntoView(alignToTop);

                    if (lockedRow.length)
                    {
                        lockedRow[0].scrollIntoView(alignToTop);
                    }
                };

                if (rowTop < bodyTop)
                {
                    scrollRowIntoView(true);
                }
                else if (rowBottom > bodyBottom)
                {
                    scrollRowIntoView(false);
                }
            }

            var addRowHighlighting = false;

            if (recordChanged && !isDeselectPreviousRecordOverridden(browseName))
            {
                deselectPreviousRecord(browseName);
                addRowHighlighting = !browse.disableRowHighlighting;
            }

            browse.currentRow = row;

            var browseElement = $("#" + browseName);

            browseElement.children(".selectedPK").val(browse.primaryKeys[row]);

            if (addRowHighlighting)
            {
                var rows = lockedRow.add(unlockedRow);
                if (rows.length > 0)
                {
                    rows.addClass(classNames.current);
                    rows.find("svg").addClass(classNames.browseRowContent);
                    rows.eq(-1).attr("aria-selected", true);
                }
            }

            if (browse.relatedBrowses && settings.loadRelatedBrowses)
            {
                getRelatedBrowses(browse, row, browseName);
            }

            // When paging forward/back, if you were on the first row, the row number will be unchanged and recordChanged will be false.
            // We still want to save the browse seek ID in that case, otherwise you will be taken to your prior seek position when you
            // reload the page.
            if (settings.updateBrowseSeekInfo)
            {
                skyward.browseSeekInfo.save(browse);
            }

            if (settings.setCurrentBrowseName)
            {
                skyward.browse.setCurrentBrowseName(browseName);
            }

            if (recordChanged)
            {
                browseElement.trigger("rowChanged", browse);
            }

            return recordChanged;
        };
        skyward.browse.registerBrowse = function (browseRequestName, browseName, browseViewId, browseId, browseIDHash, recordCount, currentRow, primaryKeys, columnFieldNames, browseFilterId, browseFilterIdHash, browseSearchCondition, browseSearchConditionHash, userSearchCondition, userSearchConditionHash, codeEelSearchText, selectMode, rowModule, rowObject, rowScreen, taskName, hidePreviewDetailsButton, hideBrowseControl, hideSelectListTotals, hasCollapseExpandButton, renderLeftControls, renderSearchBox, renderViewButton, renderFilterButton, renderLiveTileAddButton, renderChartTileAddButton, rowData, rowDataHash, disableBrowseSort, hideOptionsButton, hideReportsFromRelatedScreen, tempTableName, confirmationMessage, confirmationMessageContainer, renderHeaderSettings, renderSortableHeader, detailsPanelType, firstRowIdentityFieldValues, lastRowIdentityFieldValues, preComputedRecordCount, renderRowsPerPageOption, skywardID, rowsPerPageCap)
        {
            var thisBrowse = getBrowseByName(browseName);

            if (!thisBrowse)
            {
                return;
            }

            if (!thisBrowse.data)
            {
                thisBrowse.data = {};
            }
            var browseHtmlId = "#" + browseName;
            var browseContainer = thisBrowse.browse != null ? $(thisBrowse.browse) : $(browseHtmlId);

            if (shouldProcessMobileBrowse(thisBrowse))
            {
                // Move scripts out of the browse before converting to an HTML string.  Otherwise, when we convert
                // it back, jQuery will synchronously load them.
                const scripts = browseContainer.find("script");
                document.body.append(scripts);

                initMobileBrowse(browseContainer, browseContainer.html(), thisBrowse);
            }

            var oldTotalData = thisBrowse.totals || {};

            const isInDetailsPanel = browseContainer.hasClass(classNames.isInDetailsPanel);

            // Only bind cleanup events on the initial registration of the browse
            if (thisBrowse.isRegistered === undefined || thisBrowse.isRegistered === false)
            {
                bindBrowseCleanupEvents(browseName, thisBrowse, browseContainer, isInDetailsPanel);
            }

            $.extend(thisBrowse,
                {
                    browse: browseContainer,
                    controls: $(browseHtmlId + "_controls"),
                    quickFilter: browseContainer.find(".js-expandableQuickFilter"),
                    seek: $(browseHtmlId + "_seek"),
                    searchContainer: browseContainer.find(".browseSearch"),
                    header: $(browseHtmlId + "_header"),
                    lockedHeader: $(browseHtmlId + "_lockedHeader"),
                    unlockedHeader: $(browseHtmlId + "_unlockedHeader"),
                    body: $(browseHtmlId + "_body"),
                    lockedBody: $(browseHtmlId + "_lockedBody"),
                    unlockedBody: $(browseHtmlId + "_unlockedBody"),
                    footer: $(browseHtmlId + "_footer"),
                    baseErrorDiv: browseContainer.find(".currentRecordContentBaseError"),
                    viewId: browseViewId,
                    browseId: browseId,
                    browseIDHash: browseIDHash,
                    browseName: browseRequestName,
                    recordCount: recordCount,
                    currentRow: currentRow,
                    primaryKeys: primaryKeys,
                    columnFieldNames: columnFieldNames,
                    contentMessageArea: undefined,
                    browseFilterId: browseFilterId,
                    browseFilterIdHash: browseFilterIdHash,
                    browseSearchCondition: browseSearchCondition,
                    browseSearchConditionHash: browseSearchConditionHash,
                    userSearchCondition: userSearchCondition,
                    userSearchConditionHash: userSearchConditionHash,
                    selectMode: selectMode,
                    sectionHeaderContainer: browseContainer.find(".sectionHeader"),
                    hidePreviewDetailsButton: hidePreviewDetailsButton,
                    rowModule: rowModule,
                    rowObject: rowObject,
                    rowScreen: rowScreen,
                    taskName: taskName,
                    hideBrowseControl: hideBrowseControl,
                    hideSelectListTotals: hideSelectListTotals,
                    rowsPerPageCap: rowsPerPageCap,
                    hasCollapseExpandButton: hasCollapseExpandButton,
                    rowData: rowData,
                    rowDataHash: rowDataHash,
                    codeEELSearchText: codeEelSearchText,
                    renderLeftControls: renderLeftControls,
                    renderSearchBox: renderSearchBox,
                    renderViewButton: renderViewButton,
                    renderFilterButton: renderFilterButton,
                    renderLiveTileAddButton: renderLiveTileAddButton,
                    renderChartTileAddButton: renderChartTileAddButton,
                    disableBrowseSort: disableBrowseSort,
                    hideOptionsButton: hideOptionsButton,
                    hideReportsFromRelatedScreen: hideReportsFromRelatedScreen,
                    tempTableName: tempTableName,
                    confirmationMessageContainer: confirmationMessageContainer,
                    confirmationMessage: confirmationMessage,
                    renderHeaderSettings: renderHeaderSettings,
                    renderSortableHeader: renderSortableHeader,
                    isInDetailsPanel: isInDetailsPanel,
                    detailsPanelType: detailsPanelType,
                    firstRowIdentityFieldValues: firstRowIdentityFieldValues,
                    lastRowIdentityFieldValues: lastRowIdentityFieldValues,
                    preComputedRecordCount: preComputedRecordCount,
                    renderRowsPerPageOption: renderRowsPerPageOption,
                    hasShadow: false,
                    totals: $.extend(oldTotalData,
                        {
                            container: browseContainer.find(".browseFooter__totalsSection")
                        }),
                    cachedSql: null,
                    skywardID: skywardID,
                    isRegistered: false,
                    rowCount: null
                }
            );

            skyward.browseFilters.preInitQuickFilter(thisBrowse);

            var browseSearchClickEventHandler = function ()
            {
                var searchText = getSearchTextValue(browseName);
                var tempTable = null;
                var browse = getBrowseByName(browseName);
                if (browse)
                {
                    tempTable = browse.tempTableName;
                }

                performSearch(browseName, { seekText: searchText, tempTableName: tempTable });
            };

            var browseSearchBox = browseContainer.find(".browseSearchBox");

            browseSearchBox.on("keydown", function (e)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(e);

                if (eventKeys.ENTER)
                {
                    var element = $(this);
                    if (element.is(".datepicker"))
                    {
                        element.datepicker("hide");
                        // Performing the search will refresh the browse DOM, which will clear the JQuery data associated with the datepicker.
                        // We need to make sure the normal datepicker event handling doesn't fire.
                        e.stopImmediatePropagation();
                    }
                    browseSearchClickEventHandler.apply(element, arguments);

                    e.stopPropagation();
                    e.preventDefault();
                }
            });

            if (skyward.global.mobileAccess && !skyward.global.mobileAccessEmulation && browseSearchBox.hasClass("datepicker"))
            {
                // The events fired on date inputs are inconsistent between Android and iOS.
                // On Android, the change event is fired after selecting a date and hitting Set. It doesn't appear to fire a blur event.
                // On iOS, the change event is fired immediately when opening an empty input and every time a new month, day or year is selected. It triggers a blur event when hitting Done.
                browseSearchBox.on(skyward.global.isAndroidApp ? "change" : "blur", function ()
                {
                    browseSearchClickEventHandler.apply(this, arguments);
                });
            }

            browseContainer.find(".searchBoxButton").on("click", browseSearchClickEventHandler);
            setupDependency(thisBrowse);
            updateBrowseTotalsRequest(thisBrowse);
            skyward.browse.addBrowseScrollEvents(thisBrowse);
            wireUpExpandCollapseBrowseButton(thisBrowse.browse);
            addBrowseControlsClickEvents(thisBrowse);
            addBrowseBodyClickEvents(thisBrowse);
            addColumnHeaderClickEvents(thisBrowse);
            if (thisBrowse.preventColumnResize !== true)
            {
                addColumnHeaderResizeEvents(thisBrowse.browse, browseName);
            }
            addPagingButtonClickEvents(browseName);
            addTotalRecordsClickEvents(browseName);

            thisBrowse.params = [];

            browseContainer.append('<input id="' + browseName + '_selectedPK" name="' + browseName + '_selectedPK"  class="selectedPK" type="hidden" />');

            browseContainer.off("click", ".browseRow .browseDataCell");

            browseContainer.on("click", ".browseRow .browseDataCell", function ()
            {
                throttledRowClick(browseName, $(this));
            });

            browseContainer.off("click", ".lockedBrowseBody .browseRow .browseRowOptions");
            browseContainer.on("click", ".lockedBrowseBody .browseRow .browseRowOptions", function (event)
            {
                //We have to add the event listener to the locked div because it is on top, but we need to select the unlocked row.
                //If a browse row button is clicked (child of the .browseRowOptions div) we want to let the button click function happen and not trigger the rowclick
                if (event)
                {
                    var eventTarget = $(event.target);
                    if (eventTarget.hasClass("button") || eventTarget.parents(".button").length > 0)
                    {
                        return;
                    }
                }
                var lockedBrowseRow = $(this).parent();
                if (lockedBrowseRow.length > 0)
                {
                    var unlockedRowID = lockedBrowseRow.attr("id").replace("locked", "unlocked");
                    var unlockedbrowseRow = $("#" + unlockedRowID);
                    var browseCell = unlockedbrowseRow.find(".browseRowOptions");
                    rowClick(browseName, browseCell);
                }
            });

            browseContainer.off("click", ".js-insertColumnButton", noColumnsInsertColumnButtonClick);
            browseContainer.on("click", ".js-insertColumnButton", noColumnsInsertColumnButtonClick);

            const openBrowseFilterDialogFor = new URLSearchParams(window.location.search).get('openBrowseFilterDialogFor');
            if (openBrowseFilterDialogFor && thisBrowse.browseName === openBrowseFilterDialogFor)
            {
                $(`#${thisBrowse.browseName}_filterButton`)?.click();
            }
        };

        skyward.browse.hideIfEmpty = function (browseContainerID)
        {
            var browseContainer = $("#" + browseContainerID);
            if (browseContainer.length > 0)
            {
                browseContainer.parent().css("display", "none");
            }
        };

        skyward.browse.resize = browseResize;

        skyward.browse.rowPopupMenu = function (rowMenuData, browseName, button, rowNumber)
        {
            var currentBrowse = getBrowseByName(browseName);

            if (currentBrowse && currentBrowse.currentRow != rowNumber)
            {
                skyward.detailsPanel.tryCloseDetailsPanel(function ()
                {
                    doRowPopup();
                });
            }
            else
            {
                doRowPopup();
            }

            function doRowPopup()
            {
                button = $(button);

                var differentBrowseClicked = skyward.browse.getCurrentBrowseName() !== browseName;

                skyward.browse.setCurrentBrowseName(browseName);

                var browse = getBrowseByName(browseName);

                if (browse && browse.detailsPanelType === browseDetailsPanel.detailsPanelTypes.row && (browse.currentRow != rowNumber || differentBrowseClicked))
                {
                    if (browse.currentRow != rowNumber)
                    {
                        skyward.browse.setCurrentRecord(browseName, rowNumber);
                    }

                    if (!browse.hidePreviewDetailsButton)
                    {
                        browseDetailsPanel.showDetailsPanel(browseName);
                    }
                }
                var modalPopUpItems = [];

                $.each(rowMenuData, function (index, value)
                {
                    if (value.type === "title")
                    {
                        modalPopUpItems.push(value);
                    }
                    else
                    {
                        if (button.data("mediaVerificationToken"))
                        {
                            value.data.mediaVerificationToken = button.data("mediaVerificationToken");
                            value.data.mediaId = button.data("mediaId");
                        }
                        createModalObject(value);
                    }
                });

                skyward.modalLayer.showMenu(modalPopUpItems, button, {});

                function createModalObject(value)
                {
                    var attributes = {};
                    for (var prop in value.data)
                    {
                        attributes["data-" + prop] = value.data[prop];
                    }

                    var menuItem =
                    {
                        type: "item",
                        text: value.text,
                        icon: value.icon,
                        click: function ()
                        {
                            var data = value.data || {};
                            if (data["click-target-id"] && data["click-target-id"] != "")
                            {
                                $("#" + data["click-target-id"]).click();
                            }
                            else if (data["click-action"] && data["click-action"] != "")
                            {
                                skyward.events.clickEvent.apply(this, arguments);
                            }
                            else
                            {
                                skyward.window.loadContent(value.target, value.module, value.object, value.screen, value.id, data, null, undefined);
                            }
                        },
                        attributes: attributes
                    };
                    modalPopUpItems.push(menuItem);
                }
            }
        };

        skyward.browse.handlePopupBrowseTabPress = function ()
        {
            var browse = getCurrentBrowse();

            if (!browse)
            {
                return;
            }
            if (browse.recordCount > 0)
            {
                $(browse.body).find(".browseRow.current a.button").first().focus();
            }
            else
            {
                $(browse.browse).find("a.button").first().focus();
            }
        };

        /**
         * Creates a new collection from browse and browseData to form a (more) complete settings/data collection for POST
         */
        skyward.browse.getRequiredBrowseData = function (browse, browseData)
        {
            browseData = browseData || {};
            var serializedPostData;
            var postData;

            var data =
            {
                pageModule: browse.pageModule, // The module of the screen the browse appears on
                pageObject: browse.pageObject,
                pageScreen: browse.pageScreen,
                browseModule: browse.browseModule, // The module specified by the browse viewpart, usually determined by the route module (area)
                browseObject: browse.browseObject,
                dataModule: browse.dataModule, // The module of the data object that the browse is based on
                dataObject: browse.dataObject,
                taskName: browse.taskName,
                browseName: browse.browseName,
                hidePrimaryBrowseButton: browseData.hidePrimaryBrowseButton || browse.hidePrimaryBrowseButton,
                labelID: browse.labelID,
                hideIfEmpty: browse.hideIfEmpty,
                selectMode: browse.selectMode,
                browseId: browse.id,
                codeEelName: browse.codeEelName && browse.codeEelName != null ? browse.codeEelName : undefined,
                codeEelCode: browse.codeEelCode && browse.codeEelCode != null ? browse.codeEelCode : undefined,
                codeEelDescription: browseData.codeEelDescription && browseData.codeEelDescription != null ? browseData.codeEelDescription : undefined,
                codeEELSearchText: browse.codeEELSearchText && browse.codeEELSearchText != null ? browse.codeEELSearchText : undefined,
                relatedBrowses: browse.relatedBrowses != null ? JSON.stringify(browse.relatedBrowses) : undefined,
                rowDataDefinitions: browse.rowDataDefinitions != null ? JSON.stringify(browse.rowDataDefinitions) : undefined,
                queryParameterData: browse.queryParameterData != null ? JSON.stringify(browse.queryParameterData) : undefined,
                timestamp: new Date().getTime(),
                tempTableName: browseData.tempTableName || browse.tempTableName || undefined,
                displayName: browse.displayName ? browse.displayName : browseData.displayName,
                dynamicHeight: browse.dynamicHeight,
                readNoLock: browseData.readNoLock ? true : false,
                hideBrowseControl: browse.hideBrowseControl,
                hideSelectListTotals: browse.hideSelectListTotals,
                rowsPerPageCap: browse.rowsPerPageCap,
                renderSearchBox: browse.renderSearchBox,
                performSearch: true,
                getBrowseSearchMode: browse.getBrowseSearchMode,
                multiSelectBrowseObjectRelationship: browse.multiSelectBrowseObjectRelationship,
                multiSelectBrowseObjectRelationshipField: browse.multiSelectBrowseObjectRelationshipField,
                multiSelectBrowseContextId: browse.multiSelectBrowseContextId,
                multiSelectBrowseIsReverseRelationship: browse.multiSelectBrowseIsReverseRelationship,
                segmentedBrowseParentField: browse.segmentedBrowseParentField,
                segmentedRowHeaderDisplayData: browse.segmentedRowHeaderDisplayData != null ? JSON.stringify(browse.segmentedRowHeaderDisplayData) : undefined,
                dataType: browseData.dataType,
                browseFilterId: browseData.browseFilterId,
                hasCollapseExpandButton: browse.hasCollapseExpandButton,
                routeHash: browse.routeHash,
                disableRowHighlighting: browse.disableRowHighlighting,
                preventColumnResize: browse.preventColumnResize,
                preventColumnSort: browse.preventColumnSort,
                renderLeftControls: browse.renderLeftControls,
                renderViewButton: browse.renderViewButton,
                renderFilterButton: browse.renderFilterButton,
                renderLiveTileAddButton: browse.renderLiveTileAddButton && !browse.isRelatedBrowse,
                renderChartTileAddButton: browse.renderChartTileAddButton && !browse.isRelatedBrowse,
                renderRowsPerPageOption: browse.renderRowsPerPageOption,
                disableBrowseSort: browse.disableBrowseSort,
                hideOptionsButton: browse.hideOptionsButton,
                hideReportsFromRelatedScreen: browse.hideReportsFromRelatedScreen,
                additionalfieldinfo: browse.additionalfieldinfo,
                sortfieldinfo: browse.sortfieldinfo,
                distinctfield: browse.distinctfield,
                hidedistinctfield: browse.hidedistinctfield,
                rendernodatarow: browse.rendernodatarow,
                distinctfieldwidth: browse.distinctfieldwidth,
                selectedItemKeys: browse.selectedItemKeys,
                dependentFilterPromptValues: browse.dependentFilterPromptValues,
                promptIsList: browse.promptIsList,
                filter: browse.filter,
                renderDesignReportButton: browse.renderDesignReportButton,
                parentPrimaryKeyID: browseData.parentPrimaryKeyID && browseData.parentPrimaryKeyID != null ? browseData.parentPrimaryKeyID : undefined,
                hideMoreMenuArea: (browse.hideMoreMenuArea == "true" || browse.hideMoreMenuArea ? true : false),
                renderSortableHeader: browse.renderSortableHeader,
                renderHeaderSettings: browse.renderHeaderSettings,
                isOnTheFly: browse.isOnTheFly,
                hiddenBackingDataId: browse.hiddenBackingDataId,
                detailsPanelType: browse.detailsPanelType,
                pagingType: browseData.pagingType,
                identifyingFieldsAndValues: skyward.extensions.encodeHtml(getIdentityFieldValuesBasedOnType(browseData.pagingType, browse)),
                identityFieldValuesOfTopRecord: skyward.extensions.encodeHtml(browse.firstRowIdentityFieldValues),
                seekText: getSearchTextValue(browse.id),
                renderQuickFilter: browse.renderQuickFilter && !browse.isRelatedBrowse && !browse.isInDetailsPanel && browse.browse.closest(".workflow").length === 0,
                headerNumber: getHeaderNumber(browse),
                forceSingleThread: browseData.forceSingleThread ?? false
            };

            if (browse.data)
            {
                postData = browse.data;
                //ensure that empty parameters are not passed for rowData and rowDataHash
                if (!browse.data.rowData)
                {
                    postData = $.extend({}, browse.data);
                    delete postData.rowData;
                    delete postData.rowDataHash;
                }
                serializedPostData = JSON.stringify(postData);
            }
            data.postData = serializedPostData;

            $.extend(data, getBrowseType(browse));

            $.extend(data, skyward.browseSeekInfo.setAndGet(browse, browseData));

            if (!data.hidePrimaryBrowseButton)
            {
                const parentBrowse = getParentBrowse(browse);
                const parentBrowseIsEmpty = parentBrowse && parentBrowse.primaryKeys.length === 0;
                data.hidePrimaryBrowseButton = parentBrowseIsEmpty;
            }

            return data;
        };

        skyward.browse.get = function (browseId, browseData, moreData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            if (browse.data?.filter)
            {
                browse.data.filter = skyward.extensions.encodeHtml(browse.data.filter);
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);

            if (moreData != null)
            {
                data = $.extend({}, data, moreData);
            }

            data.performSearch = browse.getBrowseSearchMode === undefined || browse.getBrowseSearchMode === "Always";
            return requestBrowse(browseId, browse, data, "GetBrowse");
        };

        skyward.browse.changeView = function (browseId, browseData, additionalPostData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            var postData = data;

            if (additionalPostData != null && !$.isEmptyObject(additionalPostData))
            {
                postData = $.extend({}, additionalPostData, data);
            }

            postData.viewId = browseData.viewId;
            postData.seekId = -1;

            return requestBrowse(browseId, browse, postData, "ChangeBrowseView");
        };

        skyward.browse.changeFilter = function (browseId, browseData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.currentPage = browseData.currentPage;
            data.seekId = -1;

            var options =
            {
                moduleOverride: browse.dataModule,
                objectOverride: browse.dataObject
            };

            return requestBrowse(browseId, browse, data, "ChangeBrowseFilter", options);
        };

        skyward.browse.updateQuickFilter = function (browseId, filterData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse);
            data.seekId = -1;
            data.filter = filterData;

            return requestBrowse(browseId, browse, data, "UpdateFilterAndView");
        };

        skyward.browse.changePage = function (browseId, browseData)
        {
            var browse;
            if (browseData == null)
            {
                var pagingButtonData = $(this).data();
                browseData = pagingButtonData;
                browse = skyward.browse.getContainingBrowse(this);
            }
            else
            {
                browse = getBrowseByName(browseId);
            }

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.seekId = -1;
            data.currentPage = browseData.currentPage;
            return requestBrowse(browse.id, browse, data, "ChangeBrowsePage");
        };

        skyward.browse.updateDependency = function (browseId, browseData)
        {
            var browse;
            if (browseData == null)
            {
                var pagingButtonData = $(this).data();
                browseData = pagingButtonData;
                browse = skyward.browse.getContainingBrowse(this);
            }
            else
            {
                browse = getBrowseByName(browseId);
            }

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            // Add editable dependency to browse data
            for (var key in browseData.dependencyPostData)
            {
                browse.data[key] = browseData.dependencyPostData[key];
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.seekId = -1;
            data.currentPage = browseData.currentPage;

            if (browse.browseType == "Checkbox")
            {
                // Reset CheckboxBrowse State
                data.resetValues = true;
            }

            return requestBrowse(browse.id, browse, data, "ChangeBrowsePage");
        };

        skyward.browse.changeRowsPerPage = function (browseId, browseData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            browse.rowsPerPage = data.rowsPerPage = browseData.rowsPerPage;

            return requestBrowse(browseId, browse, data, "ChangeBrowseRowsPerPage");
        };

        skyward.browse.resetViewAndFilter = function (browseViewId, browseFilterId, browseName, data)
        {
            var postData = $.extend({}, data,
                {
                    browseViewID: browseViewId,
                    browseFilterID: browseFilterId
                });
            return $.ajax(
                {
                    url: skyward.global.virtualDir + "SkySys/BrowseView/ResetViewAndFilter",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (responseData)
                    {
                        if (responseData.success)
                        {
                            // Even though we update the filter and view on this browse for the user, calling
                            // changeView() will cause the browse to reload, taking care of the changed view and filter.
                            skyward.browse.changeView(browseName, { viewId: responseData.browseViewId });
                        }
                    }
                });
        };

        /**
         * Update the height of the locked browse to ensure the locked browse is sized correctly in
         * order to allow vertical scrolling, and not cover the browse's horizontal scrollbar.
         * <br/>
         * This should be called any time the browse's vertical size changes, as well as the first
         * time it's displayed, if it was hidden when the page loaded.
         * @param {object} browse - The browse object representing the browse to resize
         */
        skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar = function (browse)
        {
            if (browse && browse.unlockedBody && browse.unlockedBody.length && browse.lockedBody && browse.lockedBody.length)
            {
                var unlockedBrowseBody = browse.unlockedBody;
                var lockedBrowseBody = browse.lockedBody;
                var lockedBrowseBodyWrapper = lockedBrowseBody.parent();
                if (skyward.window.hasHorizontalScrollBar(unlockedBrowseBody))
                {
                    lockedBrowseBodyWrapper.css("bottom", skyward.window.scrollbarHeight + "px");
                }
                else
                {
                    lockedBrowseBodyWrapper.css("bottom", "0px");
                }
            }
        };

        skyward.browse.performGradebookCodeEELSearch = function (browseId, browseData, codeEELSearchText)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            $.extend(data, browseData);
            data.codeEELSearchText = skyward.extensions.encodeHtml(codeEELSearchText);

            return requestBrowse(browseId, browse, data, "GradebookCodeEELViewSearchResults");
        };

        skyward.browse.performCodeEELSearch = function (browseId, browseData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.codeEELSearchText = skyward.extensions.encodeHtml(browseData.codeEELSearchText);

            var selectTopRecord = data.seekId === undefined || typeof browseData.codeEELSearchText === "string";
            if (selectTopRecord)
            {
                data.seekId = -1;
                data.pagingType = "FirstPage";
            }

            return requestBrowse(browseId, browse, data, "PerformCodeEELSearch");
        };

        skyward.browse.performDistinctMultiSelectEELSearch = function (browseId, browseData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            browse.displayName = browseData.isSingleSelect ? "Single Select EEL" : "Multi Select EEL";
            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.distinctMultiSelectEELSearchText = browseData.distinctMultiSelectEELSearchText;
            data.isSingleSelect = browseData.isSingleSelect;
            data.allowMassSelect = browseData.allowMassSelect;

            return requestBrowse(browseId, browse, data, "PerformDistinctMultiSelectEELSearch");
        };

        skyward.browse.getSelectedRecordValue = function (browseId)
        {
            const browse = getBrowseByName(browseId);
            if (browse && browse.primaryKeys.length > browse.currentRow)
            {
                return browse.primaryKeys[browse.currentRow];
            }
            return null;
        };

        skyward.browse.shouldIgnoreKeyboardEvent = function (node)
        {
            // Don't allow the browse to take over keyboard events for input elements
            return $(node).is("input:not(.eELInputContainer__textBox):not(.distinctMultiSelectUserInput):not(.accountDimensionEELCode), textarea, select, .tabListNavigator *");
        };

        /**
        * Get a Browse object for an element within the browse
        * @param {element} elementParam An element within a browse
        * @returns {Browse | undefined} The Browse containing the element, or undefined
        */
        skyward.browse.getContainingBrowse = function (elementParam)
        {
            var element = $(elementParam);
            var browseId = element.closest(classNames.browse.dot()).attr("id");
            return getBrowseByName(browseId);
        };

        /**
        * Get a Browse object for the first browse within a container element
        * @param {element} elementParam An element that contains a browse
        * @returns {Browse | undefined} The Browse within the element, or undefined
        */
        skyward.browse.getInnerBrowse = function (elementParam)
        {
            const element = $(elementParam);
            const browseId = element.find(classNames.browse.dot()).first().attr("id");
            return getBrowseByName(browseId);
        };

        /**
        * Get the current browse name
        * @returns {string} The browse name
        */
        skyward.browse.getCurrentBrowseName = function ()
        {
            // Remove browses that no longer exist in the dom
            skyward.browse.openBrowses = skyward.browse.openBrowses.filter(function (browseName)
            {
                return document.getElementById(browseName) && browseName !== "ProfileControlsBrowse";
            });

            var focusedBrowse = skyward.browse.getContainingBrowse(document.activeElement);
            if (focusedBrowse && !isHiddenByModalLayer(focusedBrowse.browse) && !isHidden(focusedBrowse.browse))
            {
                return focusedBrowse.id;
            }

            // Find current browse name
            for (var i = skyward.browse.openBrowses.length - 1; i >= 0; i--)
            {
                var browseName = skyward.browse.openBrowses[i];
                var thisBrowse = $(document.getElementById(browseName));

                if (isHiddenByModalLayer(thisBrowse))
                {
                    continue; // this browse is on the DOM but underneath another layer.
                }
                return browseName;
            }

            return null;

            function isHiddenByModalLayer(browse)
            {
                if (browse === undefined)
                {
                    return false;
                }
                return browse.closest("#master," + classNames.modalLayerContainer.dot()).nextAll(classNames.modalLayerContainer.dot()).length !== 0;
            }

            function isHidden(browse)
            {
                if (browse === undefined)
                {
                    return false;
                }
                return browse.is(":visible");
            }
        };

        skyward.browse.setCurrentBrowseName = function (browseName)
        {
            var openBrowses = skyward.browse.openBrowses;
            var oldIndex = openBrowses.indexOf(browseName);

            if (oldIndex > -1 && oldIndex !== openBrowses.length - 1)
            {
                openBrowses.splice(openBrowses.length - 1, 0, openBrowses.splice(oldIndex, 1)[0]);
                updateActiveBrowseClasses();
            }
        };

        skyward.browse.getBrowseStats = function (browseName)
        {
            return allBrowseStats[browseName];
        };

        skyward.browse.getSql = function (browseName)
        {
            var browse = getBrowseByName(browseName);
            if (!browse)
            {
                return null;
            }
            if (!browse.cachedSql)
            {
                var data = skyward.browse.getRequiredBrowseData(browse);
                browse.cachedSql = $.ajax(
                    {
                        url: skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + "/GetBrowseSQL",
                        // otherwise the activity indicator will trigger a mouseleave
                        activityIndicator: { hideGlass: true },
                        type: "POST",
                        datatype: "JSON",
                        data: data
                    })
                    .then(function (data)
                    {
                        return data.success ? data.query : "Unable to retrieve query.";
                    });
            }
            return browse.cachedSql;
        };

        skyward.browse.primaryButtonClick = function (browseName, rowNumber, target, module, object, screen, primaryKeyValue, mediaVerificationToken, data, event, allowClickActionForMobile)
        {
            function doClick()
            {
                skyward.browse.setCurrentRecord(browseName, rowNumber, { setCurrentBrowseName: true, loadRelatedBrowses: true });

                if (target == "" || module == "" || object == "" || screen == "")
                {
                    return;
                }

                skyward.window.loadContent(target, module, object, screen, primaryKeyValue, data, null, null, null, false, null, null, mediaVerificationToken);
            }

            /* in mobile, detail links can now contain actionable elements. if one of these elements are clicked, cancel the detail click */
            if (skyward.global.mobileAccess && allowClickActionForMobile !== true && event && $(event.target).closest("a[data-click-action]").length)
            {
                return;
            }

            if (event && $(event.target).closest(".button"))
            {
                var button = $(event.target).closest(".button");

                if (button.hasClass("ui-disabled"))
                {
                    return;
                }

                button.addClass("ui-disabled");

                setTimeout(function ()
                {
                    button.removeClass("ui-disabled");
                }, 500);
            }

            skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
            {
                if (wasDirty === true)
                {
                    skyward.window.skipUnloadCheck = true;
                }
                doClick();
            });
        };

        skyward.browse.bindLockedBodySimulatedFocus = function (element)
        {
            var eventSelector = ".unlockedBrowseBody :focusable, .unlockedHeader :focusable";
            element
                .off("focus", eventSelector, addSimulatedFocus).on("focus", eventSelector, addSimulatedFocus)
                .off("blur", eventSelector, removeSimulatedFocus).on("blur", eventSelector, removeSimulatedFocus);
        };

        skyward.browse.browseLinkColumnPopup = function (module, object, action, headerText, data)
        {
            let jsonData = JSON.parse(data || "{}");

            let buildPopup = function ()
            {
                return $.ajax(
                    {
                        url: skyward.global.virtualDir + module + "/" + object + "/" + action + "?renderType=contentOnly",
                        type: "POST",
                        dataType: "viewparthtml",
                        data: jsonData
                    }
                );
            };
            let options = JSON.parse(jsonData["browse.options"] ? jsonData["browse.options"] : "{}");
            options.draggable = true;
            let finalHeaderText = jsonData["browse.headertext"] ? jsonData["browse.headertext"] : headerText;
            let button = jsonData["browse.button"] ? JSON.parse(jsonData["browse.button"]) : null;
            let buttons = [];
            if (button && button.click)
            {
                button.click = eval("(" + button.click + ")");
                buttons.push(button);
            }
            let cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
            buttons.push(cancelButton);
            
            let dialog = skyward.modalLayer.showDialog(finalHeaderText, buildPopup, buttons, options);

            if (jsonData.browseNameToTriggerResize)
            {
                addBrowseLoadResizeHandler(jsonData.browseNameToTriggerResize);
            }
            else
            {
                dialog.bodyPromise.done(function ()
                {
                    dialog.content.find(".browse").each(function ()
                    {
                        addBrowseLoadResizeHandler(this.id);
                    });
                });
            }

            function addBrowseLoadResizeHandler(browseName)
            {
                $(document.body).one("browseLoaded." + browseName, function ()
                {
                    var browse = $("#" + browseName);
                    var browseBody = browse.find(".browseBody");
                    var unlockedBrowseTable = browse.find(".unlockedBrowseTable");
                    browseBody.css("max-height", "55vh");
                    browseBody.css("height", unlockedBrowseTable.height());
                    dialog.animateModalContents();
                });
            }
        };

        /**
        * Send a click to the browse row a DOM element belongs to.
        * This is helpful to trigger row changes from custom click-action buttons.
        * @param {element} element the target element
        */
        skyward.browse.selectRowByElement = function (element)
        {
            var browse = skyward.browse.getContainingBrowse(element);
            var row = $(element).closest(".browseRow");
            if (browse === undefined || row.length < 1)
            {
                return;
            }
            skyward.browse.setCurrentRecord(browse.id, row.find(".browseRowOptions, .browseDataCell").first().data("row"));
        };

        skyward.browse.addBrowseScrollEvents = function (browse)
        {
            var scrollEventParams =
            {
                unlockedBody: browse.unlockedBody,
                lockedBody: browse.lockedBody,
                unlockedHeader: browse.unlockedHeader,
                totals: browse.totals,
                scrollCallback: function ()
                {
                    updateDropShadows(browse);
                }
            };

            skyward.browse.addBrowseScrollEventsGeneric(scrollEventParams);
        };

        /**
         * Adds scroll events to the target browse bodies without the use of skyward.browse.browseList objects
         * 
         * @param {Object} params Parameter object containing scroll event parameters
         * @param {JQuery} params.unlockedBody Unlocked Body of the browse
         * @param {JQuery} params.lockedBody Locked Body of the browse
         * @param {JQuery} params.unlockedHeader Unlocked Header of the browse
         * @param {Object} params.totals Object containing browse totals information (optional)
         * @param {Function} params.scrollCallback Callback for custom event handling (optional)
         */
        skyward.browse.addBrowseScrollEventsGeneric = function (params)
        {
            var focusedBody;

            var attachScrollEvent = function (scrollBody, otherBody)
            {
                var scrollEventHandler = function ()
                {
                    if (!focusedBody)
                    {
                        focusedBody = scrollBody;
                    }

                    otherBody.prop("scrollTop", scrollBody[0].scrollTop);

                    if (scrollBody === params.unlockedBody)
                    {
                        var scrollLeft = scrollBody[0].scrollLeft;
                        params.unlockedHeader.prop("scrollLeft", scrollLeft);
                        if (params.totals)
                        {
                            params.totals.container.prop("scrollLeft", scrollLeft);
                        }
                    }

                    if (typeof params.scrollCallback === "function")
                    {
                        params.scrollCallback.apply(this, arguments);
                    }                    
                };

                scrollBody.on("mouseover", setFocusedBodyFromScrollBody);

                if (skyward.window.isTouchDevice())
                {
                    scrollBody.on("touchstart", setFocusedBodyFromScrollBody);
                }

                function setFocusedBodyFromScrollBody()
                {
                    focusedBody = scrollBody;
                }

                scrollBody.on("scroll", scrollEventHandler);

                // Trigger the scroll event handler shortly after the user stops scrolling
                // to ensure we don't end the scrolling with the rows slightly ajar.
                scrollBody.debounce("scroll", scrollEventHandler, 50);
            };

            attachScrollEvent(params.lockedBody, params.unlockedBody);
            attachScrollEvent(params.unlockedBody, params.lockedBody);
        };

        skyward.browse.prepMobileBrowseData = function (dataHtml)
        {
            return $(dataHtml.replace(/width:/gi, "x:"));
        };

        skyward.browse.applyMobileLockedColumn = function (container, browseBody, unlockedBrowseBody)
        {
            var containerDiv = $(container);
            if (!containerDiv.length)
            {
                return;
            }
            if (!browseBody)
            {
                browseBody = containerDiv.find(".browseBody");
            }
            if (!unlockedBrowseBody)
            {
                unlockedBrowseBody = containerDiv.find(".unlockedBrowseBody");
            }
            var lockedColumnWidth;
            var containerId = containerDiv.attr("id");
            var mobileStyleTagId = containerId + "_mobileBrowseStyles";
            var useLockedHeaderAndFooter = browseBody.is(":scrollable");
            var containerSelector = "#" + containerId + "." + mobileBrowseClasses.mobileBrowseContainer;
            var styles = [];

            $(document.head).find("#" + mobileStyleTagId).remove();
            unlockedBrowseBody.find(mobileBrowseClasses.lockedColumnCell.dot()).removeClass(mobileBrowseClasses.lockedColumnCell);

            /* set the width and height on the first two cells of the table */
            unlockedBrowseBody.find("td:first-child").each(function ()
            {
                var cell = $(this);
                var cellId = this.id;

                if (!cellId)
                {
                    cellId = this.parentElement.id + "_cell" + this.cellIndex;
                    this.id = cellId;
                }

                if (typeof lockedColumnWidth === "undefined")
                {
                    lockedColumnWidth = cell.outerWidth();
                }

                var cellSelector = containerSelector + " .browseBody #" + CSS.escape(cellId);

                var row = cell.closest("tr");
                var rowSelector = containerSelector + " .browseBody #" + CSS.escape(row[0].id);
                styles.push(cellSelector + "," + cellSelector + " td, " + rowSelector + " {height:" + row.outerHeight() + "px;}");

                cell.addClass(mobileBrowseClasses.lockedColumnCell);
            });

            /* set the widths on header cells */
            unlockedBrowseBody.children("table").children("thead").children("tr").children("td").each(function ()
            {
                var cell = $(this);
                // We use this to set CSS widths later, and since we are using box-sizing: border-box, we need to use a width measurement
                // that includes borders, such as offsetWidth, $.outerWidth(false), or computedStyle.width
                var width = this.offsetWidth;

                if (this.cellIndex === 0)
                {
                    if (useLockedHeaderAndFooter)
                    {
                        var row = cell.closest("tr");
                        var rowSelector = containerSelector + " .browseHeader #" + CSS.escape(row[0].id);
                        styles.push(rowSelector + " {height:" + row.outerHeight() + "px;}");

                        cell.addClass(mobileBrowseClasses.lockedColumnCell);
                        var headerSelector = containerSelector + " .unlockedHeader td:nth-child(" + (this.cellIndex + 1) + ")";
                        styles.push(headerSelector + " {position: fixed;background-color: inherit;z-index: 1;height:" + cell.parent().height() + "px;}");
                        var footerSelector = containerSelector + " .browseFooter__totalsSection--locked td:nth-child(" + (this.cellIndex + 1) + ")";
                        styles.push(footerSelector + " {position: fixed;z-index: 1}");
                    }
                }
                else
                {
                    styles.push(containerSelector + " td:nth-child(" + (this.cellIndex + 1) + ")  {width:" + width + "px;min-width:" + width + "px;}");
                }
            });

            styles.push(containerSelector + " td:nth-child(1){width:" + lockedColumnWidth + "px;min-width:" + lockedColumnWidth + "px;}");

            if (useLockedHeaderAndFooter)
            {
                containerDiv.find(".unlockedHeader td:first-child").addClass(mobileBrowseClasses.lockedColumnCell);
                var totalsSection = containerDiv.find(".browseFooter__totalsSectionLockedWrapper .browseFooter__totalsSection");
                if (totalsSection.length)
                {
                    totalsSection.addClass("browseFooter__totalsSection--locked");
                    totalsSection.css("padding-bottom", (totalsSection[0].getBoundingClientRect().bottom - $("#" + containerId + "_footer").offset().top) + "px");
                }
                styles.push(containerSelector + " .browseHeader .unlockedHeader {margin-top:1px;right:" + skyward.window.scrollbarHeight + "px;}");
            }
            else
            {
                containerDiv.find(".browseHeader").remove();
                containerDiv.find(".browseFooter__totalsSectionLockedWrapper").remove();
            }

            if (skyward.global.isIosApp)
            {
                // Mobile iOS doesn't redraw all the affected elements (namely, position: absolute) when a style is added to the head
                // We force a full page redraw to rectify this
                styles.push("body { transform: -webkit-transform: translate3d(0,0,0); transform: translate3d(0,0,0); }");
            }

            $(document.head).append($('<style id="' + mobileStyleTagId + '" type="text/css">' + styles.join("\n") + '</style>'));
        };

        skyward.browse.getDebugName = function (browseData)
        {
            var title = browseData.displayName;

            title += (browseData.codeEelName !== undefined) ? " EEL: " : ": ";
            var skywardIdString = "{" + (browseData.skywardID || "Custom or On The Fly") + "}";
            return title + skywardIdString;
        };

        // Run all initial processes in a function for organizational purposes
        initialize();

        function bindBrowseCleanupEvents(browseName, thisBrowse, browseContainer, isInDetailsPanel)
        {
            if (isInDetailsPanel)
            {
                // Since the details panel can be detached, we need to wait until the content is 
                // totally cleared before removing broses from the browse list
                const callbackHandler = function (_data, _additionalData)
                {
                    delete skyward.browse.browseList[browseName];
                    skyward.detailsPanel.eventCallbacks.empty.deregisterCallback(callbackHandler);
                }
                skyward.detailsPanel.eventCallbacks.empty.registerCallback(callbackHandler);
            }
            else
            {
                // Remove browses from the browseList when the container is removed from the DOM
                skyward.window.registerDOMUnloadCallback(browseContainer)
                    .then(cleanupBrowseListWhenBrowseRemoved)
                    .catch(err => { });
                // When window.loadContent replaces content, the DOMUnloadCallback is called too late.
                // Add a handler here to ensure the browse data is cleaned up before the content is changed, not after.
                $(document.body).on("DOMInsertionPreLoad", browseWillBeRemovedHandler);
            }

            function browseWillBeRemovedHandler(eventData)
            {
                const target = eventData.target;
                if (target.contains(browseContainer.get(0)))
                {
                    cleanupBrowseListWhenBrowseRemoved();
                }
            };

            function cleanupBrowseListWhenBrowseRemoved()
            {
                if (skyward.browse.browseList[browseName] === thisBrowse)
                {
                    delete skyward.browse.browseList[browseName];
                }
                skyward.window.removeDOMUnloadCallback(browseContainer);
                $(document.body).off("DOMInsertionPreLoad", browseWillBeRemovedHandler);
            }
        }

        function addSimulatedFocus()
        {
            $("#" + this.id + "_lockedMirror").addClass("simulateFocus");
            skyward.browse.selectRowByElement(this);
        }

        function removeSimulatedFocus()
        {
            $("#" + this.id + "_lockedMirror").removeClass("simulateFocus");
        }

        // ChangeRow() is called only by keyDown, which is called for the initial keydown and all repeats.  A different method, rowChange(),
        // is called on keyUp, only when the key is finally released.  This method should include only things that can't wait, like changing
        // the visible current row and showing the dirty details panel warning.  Everything else, like changing the details panel and related
        // browses, should be handled in keyUp.
        function changeRow(browseName, browse, rowNumber)
        {
            if (skyward.browse.getCurrentBrowseName() !== browseName)
            {
                skyward.browse.setCurrentBrowseName(browseName);
            }
            else if (browse.currentRow === rowNumber)
            {
                return;
            }

            browseDetailsPanel.tryRowChange(browseName, doChangeRow, false);

            function doChangeRow()
            {
                skyward.browse.setCurrentRecord(browseName, rowNumber, { loadRelatedBrowses: false, setCurrentBrowseName: true, updateBrowseSeekInfo: false });
            }
        }

        function getSearchTextValue(browseName)
        {
            var browse = getBrowseByName(browseName);
            if (!browse)
            {
                return "";
            }

            var control = browse.seek;
            var searchContainer = browse.searchContainer;
            if (!control || !searchContainer || control.hasClass("js-noSearchAvailable"))
            {
                return "";
            }

            var fieldType = searchContainer.data("fieldType");

            var searchText;
            switch (fieldType)
            {
                case "date":
                    searchText = $.datepicker.formatDate("mm/dd/yy", skyward.controls.getValue(control));
                    if (!skyward.validation.validDate(searchText))
                    {
                        return;
                    }
                    break;
                case "number":
                    searchText = skyward.controls.getValue(control);
                    if (!skyward.validation.validNumber(searchText))
                    {
                        return;
                    }
                    break;
                default:
                    searchText = skyward.controls.getValue(control);
            }

            return searchText;
        }

        function browseLoadedSuccess(browse, data, localStopwatch, totalStopwatch, downloadTime, doRequest)
        {
            var browseStats = {};
            browseStats["Server Response"] = downloadTime;
            browseStats["DOM Insertion"] = localStopwatch.duration();
            localStopwatch.restart();

            let script = data.script;
            const urlInText = /\n\/\/# (sourceMappingURL|sourceURL)[^\n]*\n?$/.test(script);
            if (!urlInText)
            {
                script += `\n//# sourceURL=registerBrowse_${browse.id}_eval.js`;
            }
            eval(script);
            skyward.window.notifyDOMLoad("#" + browse.id);

            browseStats["Script Execution"] = localStopwatch.duration();
            browseStats.Total = totalStopwatch.duration();

            allBrowseStats[browse.id] = browseStats;

            if (browseDetailsPanel.currentDetailsBrowse == browse.id && ($("#" + browse.id + " .browseRow.noRecordsInBrowse").length > 0 || browse.body.find(".cmaErrorMessage").length > 0))
            {
                browseDetailsPanel.hideDetailsPanel(false);
            }

            //ensure related browses clear if their parent has no records
            if (browse.currentRow == null && browse.relatedBrowses)
            {
                var targetID = getCurrentRecordTargetId(browse.browseName);
                $.each(browse.relatedBrowses, function (browseKey, browseValue)
                {
                    getRelatedBrowse(browseValue.BrowseID, browse.primaryKeys.length == 0, browse.rowData, browse.rowDataHash, browse.currentRow, targetID);
                });
            }

            if (browse.refreshTimeout != -1)
            {
                if (refreshTimeout != null)
                {
                    clearTimeout(refreshTimeout);
                }
                browse.timestamp = 0;
                refreshTimeout = setTimeout(doRequest, browse.refreshTimeout);
            }

            enforceAccessibility(browse);
        }

        function enforceAccessibility(browse)
        {
            let headerCells;
            browse.body.find(".browseDataCell").each(function() 
            {
                if (handleSegmentedBrowseTotalsRow(this))
                {
                    return;
                }

                addSpanToBlankCells(this);
            });

            // We want to notify the users with screen readers that this row is showing totals
            function handleSegmentedBrowseTotalsRow(ele)
            {
                const jQueryElement = $(ele);
                if (jQueryElement.hasClass("segmentedRowHeader") && jQueryElement[0].children?.length == 1 && $(jQueryElement[0].children[0]).hasClass("js-segmentedRowHeaderDescription"))
                {            
                    let columnIndex = jQueryElement.attr("data-column");
                    if (!columnIndex || columnIndex == "0")
                    {
                        return;
                    }

                    columnIndex = parseInt(columnIndex);

                    if (!headerCells)
                    {
                        headerCells = browse.header.find("td");
                    }

                    const headerCellText = $(headerCells[columnIndex])?.find(".headerTextDiv");
                    if (!headerCellText || headerCellText.length == 0)
                    {
                        return;
                    }

                    const description = `Total for ${headerCellText[0].innerText} Area`;
                    jQueryElement[0].children[0].innerText = description;
                    
                    return true;
                }
            }

            // We want to add a hidden span with "Blank" to any cell that doesn't have a value for screen readers
            function addSpanToBlankCells(ele)
            {
                const wrapper = ele.children?.[0];
                if (!wrapper)
                {
                    return;
                }

                const wrapperHasChildren = wrapper.children && wrapper.children.length > 0;
                if (wrapper.innerText === "" && !wrapperHasChildren)
                {
                    const blankSpan = $("<span />").css("opacity", 0).text("Blank");
                    wrapper.appendChild(blankSpan[0]);
                }
            }
        }

        function browseResize(browseName)
        {
            var thisBrowse = getBrowseByName(browseName);

            if (!thisBrowse)
            {
                return;
            }

            var browse = thisBrowse.browse;
            var lockedBody = thisBrowse.lockedBody || $();
            var unlockedBody = thisBrowse.unlockedBody || $();

            var unlockedHeader = thisBrowse.unlockedHeader || $();
            var lockedHeader = thisBrowse.lockedHeader || $();

            var baseErrorDiv = thisBrowse.baseErrorDiv || $();
            var index;

            if (baseErrorDiv.length > 0)
            {
                var contentMessageAreaHeight = 0;
                var contentMessageArea = skyward.contentMessageArea.getContentMessageArea($("#" + thisBrowse.id).parent());
                if (contentMessageArea)
                {
                    contentMessageAreaHeight = contentMessageArea.height();
                }
                browse.css({ "top": (baseErrorDiv.outerHeight(true) + contentMessageAreaHeight) + "px" }); // Handle editable browse in details when we have errors/warnings
            }

            lockedHeader.height(unlockedHeader.height());

            thisBrowse.resize = function ()
            {
                browseResize(browseName);
            };

            skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar(thisBrowse);
            if (thisBrowse.totals && thisBrowse.totals.container.length)
            {
                thisBrowse.totals.container.find(".js-browseFooter__totalScrollbarFiller").css("width", skyward.window.scrollbarHeight + "px");
            }

            var lockedRows = lockedBody.find(".browseRow");
            if (lockedRows.length > 0)
            {
                // Used to batch up height reads and writes so we don't have to recalculate styles for the whole browse after every row
                var heights = [];
                var unlockedRows = unlockedBody.find(".browseRow");
                for (index = 0; index < unlockedRows.length; index++)
                {
                    var unlockedRow = unlockedRows[index];
                    var lockedRow = lockedRows[index];
                    if (lockedRow)
                    {
                        // This allows rows to get bigger but not smaller until the next browse load. The performance cost of allowing rows to shrink if they need to is very high.
                        var unlockedHeight = unlockedRow.getBoundingClientRect().height;
                        var lockedHeight = lockedRow.getBoundingClientRect().height;
                        if (unlockedHeight !== lockedHeight)
                        {
                            // This assumes that both the locked and unlocked columns have boxSizing: border-box and identical border sizes, so offsetHeight can
                            // be passed straight to .css().
                            // We can't use jQuery's .height() because it reads boxSizing and recomputes the height, which would force a style recalculation and
                            // prevent any speedup.
                            heights.push(unlockedHeight > lockedHeight ? { height: unlockedHeight, elem: lockedRow } : { height: lockedHeight, elem: unlockedRow });
                        }
                    }
                    else
                    {
                        break;
                    }
                }
                for (index = 0; index < heights.length; index++)
                {
                    var item = heights[index];
                    $(item.elem).css("height", item.height + "px");
                }
            }
            browse.trigger("browseResize." + browseName);
        };

        function getRelatedBrowses(browse, row, browseName)
        {
            var deferreds = [];
            var targetID = getCurrentRecordTargetId(browseName);
            $.each(browse.relatedBrowses, function (_browseKey, browseValue)
            {
                var promise = getRelatedBrowse(browseValue.BrowseID, browse.primaryKeys.length == 0, browse.rowData, browse.rowDataHash, row, targetID);
                deferreds.push(promise);
            });

            return $.when.apply($, deferreds);
        }

        function getCurrentRecordTargetId(browseName)
        {
            var browse = getBrowseByName(browseName);
            if (browse === undefined)
            {
                return null;
            }
            var row = getUnlockedRowElement(browse);
            if (row.length === 0)
            {
                return null;
            }
            return row.data("targetid");
        }

        function noColumnsInsertColumnButtonClick()
        {
            var insertColumnButton = $(this);
            var browse = skyward.browse.getContainingBrowse(insertColumnButton);
            skyward.browseeditor.popInsertColumnView(browse, -1, insertColumnButton);
        }

        /**
         * Display appropriate drop shadows for the browse's current Y scroll position.
         * @param {browseObject} thisBrowse - The browse object to update (from skyward.browse.browseList)
         */
        function updateDropShadows(thisBrowse)
        {
            var hadShadow = thisBrowse.hasShadow || false;
            var hasShadow = thisBrowse.unlockedBody.scrollLeft() !== 0;
            if (hasShadow !== hadShadow)
            {
                thisBrowse.lockedBody.toggleClass("lockedBrowseShadow", hasShadow);
                thisBrowse.lockedHeader.toggleClass("lockedBrowseShadow", hasShadow);
                if (thisBrowse.totals)
                {
                    thisBrowse.totals.container.toggleClass("lockedBrowseShadow", hasShadow);
                }
            }
            thisBrowse.hasShadow = hasShadow;
        }

        function updateActiveBrowseClasses()
        {
            var activeLayer = $(classNames.modalLayerContainer.dot()).last();

            if (activeLayer.length == 0)
            {
                activeLayer = $("#master");
            }

            var browsesInActiveLayer = [];
            activeLayer.find(classNames.browse.dot()).each(function ()
            {
                browsesInActiveLayer.push($(this));
            });

            var currentActiveBrowseInLayer = activeLayer.find(classNames.mainSelectedBrowse.dot());
            var newActiveBrowseInLayer = findActiveBrowseInLayer(browsesInActiveLayer);

            if (currentActiveBrowseInLayer.length === 0 || currentActiveBrowseInLayer.attr("id") !== newActiveBrowseInLayer.attr("id"))
            {
                currentActiveBrowseInLayer.removeClass(classNames.mainSelectedBrowse);
                if (newActiveBrowseInLayer)
                {
                    newActiveBrowseInLayer.addClass(classNames.mainSelectedBrowse);
                }
                eventCallbacks.updateActiveBrowseClasses.dispatchCallbacks();
            }
        }

        function findActiveBrowseInLayer(layerBrowses)
        {
            if (layerBrowses.length > 0)
            {
                var latestPositionInList = skyward.browse.openBrowses.indexOf(layerBrowses[0].attr("id"));
                var toReturn = layerBrowses[0];
                for (var i = 1; i < layerBrowses.length; i++)
                {
                    var id = layerBrowses[i].attr("id");
                    var positionInList = skyward.browse.openBrowses.indexOf(id);
                    if (positionInList > latestPositionInList)
                    {
                        latestPositionInList = positionInList;
                        toReturn = layerBrowses[i];
                    }
                }
                return toReturn;
            }
            return null;
        }

        function deselectPreviousRecord(browseName)
        {
            var browse = getBrowseByName(browseName);
            if (browse === undefined)
            {
                return;
            }
            getRowElements(browse).removeClass(classNames.current).attr("aria-selected", null);
        }

        function isDeselectPreviousRecordOverridden(browseName)
        {
            if (deselectPreviousRecordOverrides[browseName])
            {
                return deselectPreviousRecordOverrides[browseName](browseName) === false;
            }
            return false;
        }

        function getIdentityFieldValuesBasedOnType(pagingType, browseData)
        {
            if (pagingType === "FollowingPage")
            {
                return browseData.lastRowIdentityFieldValues;
            }
            if (pagingType === "PrecedingPage")
            {
                return browseData.firstRowIdentityFieldValues;
            }
            return null;
        }

        function browseHeaderColumnClick()
        {
            var clickedElement = $(this);

            var browseData = clickedElement.data();
            if (browseData == null)
            {
                return;
            }
            var browse = skyward.browse.getContainingBrowse(this);
            if (!browse)
            {
                return;
            }
            var columnViewIndex = browseData.columnViewIndex;

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.seekId = -1;

            var popupData =
            {
                browseId: browse.browseId,
                browseIDHash: browse.browseIDHash,
                columnViewIndex: columnViewIndex,
                fieldName: browseData.sortField,
                browseSearchCondition: browse.browseSearchCondition,
                browseSearchConditionHash: browse.browseSearchConditionHash,
                userSearchCondition: browse.userSearchCondition,
                userSearchConditionHash: browse.userSearchConditionHash,
                preventColumnSort: browse.preventColumnSort,
                preventColumnResize: browse.preventColumnResize,
                renderFilterOptions: browse.renderFilterButton
            };

            var url;
            var dialogTitle;
            if (browse.data.browseViewEditorHash)
            {
                url = skyward.global.virtualDir + "Skysys/Filter/BuildColumnFilterViewpartForBrowseViewEditor/";
                popupData.postData = JSON.stringify(browse.data);
                dialogTitle = "Options";
            }
            else
            {
                url = skyward.global.virtualDir + "skysys/filter/buildcolumnfilterviewpart/";
                popupData.browseTempTableName = browse.tempTableName;
                dialogTitle = "Column Options";
            }

            var buildPopup = function ()
            {
                return $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { hideGlass: true },
                        data: popupData
                    });
            };

            var gearIcon = clickedElement.find(".svg.Settings.svgBrowseColumnHeader");
            var saveButton = { id: "saveColumnFilter", text: "Save", click: function () { saveColumn(browse.id, browse, data, browseData.sortField, dialog); }, icon: "Save" };
            var cancelButton = { id: "cancelColumnFilter", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
            var options =
            {
                afterClose: function ()
                {
                    gearIcon.css("visibility", "");
                },
                anchorTo: skyward.global.mobileAccess ? null : clickedElement,
                id: "browseColumnOptions"
            };

            var dialog = skyward.modalLayer.showDialog(dialogTitle, buildPopup, [saveButton, cancelButton], options);
            gearIcon.css("visibility", "visible");

            dialog.content.on("contentLoaded", function ()
            {
                dialog.content.find(".js-insertColumnButton").on("click", function ()
                {
                    dialog.close();
                    skyward.browseeditor.popInsertColumnView(browse, columnViewIndex, clickedElement);
                });

                dialog.content.find(".js-deleteColumnButton").on("click", function ()
                {
                    dialog.close();
                    skyward.browseeditor.deleteColumn(browse, browseData.sortField, columnViewIndex);
                });
            });
        }

        function saveColumn(browseId, browse, data, field, dialog)
        {
            saveColumnData(browse).then(function (result)
            {
                if (result.success)
                {
                    saveColumnFilter(browseId, browse, data, field);
                    dialog.close();
                }
                else
                {
                    skyward.validation.displayValidationMessages(result, "BrowseViewColumnOptions", $("#BrowseViewColumnOptionsBaseErrors"));
                }
            });
        }

        function saveColumnData(browse)
        {
            var headerText = $("#BrowseColumnOptions_HeaderText").val();
            var width = $("#BrowseColumnOptions_Width").val();
            var columnIndex = $("#BrowseColumnOptions_ColumnIndex").val();
            var locked = $("#BrowseColumnOptions_Locked").is(":checked");
            var wrapData = $("#BrowseColumnOptions_WrapData").is(":checked");
            var columnViewIndex = $("#BrowseColumnOptions_ColumnViewIndex").val();

            var data =
            {
                headerText: headerText,
                width: width,
                columnIndex: columnIndex,
                locked: locked,
                wrapData: wrapData,
                columnViewIndex: columnViewIndex
            };

            var url;

            if (browse.data.browseViewEditorHash)
            {
                url = skyward.global.virtualDir + "Skysys/BrowseView/UpdateBrowseViewEditorBrowseColumn/";
                data.postData = JSON.stringify(browse.data);
            }
            else
            {
                url = skyward.global.virtualDir + "Skysys/BrowseView/UpdateBrowseColumn/";
                data.pageModule = browse.pageModule;
                data.pageObject = browse.pageObject;
                data.pageScreen = browse.pageScreen;
                data.browseName = browse.browseName;
                data.taskName = browse.taskName;
            }

            return $.ajax(
                {
                    url: url,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { hideGlass: true },
                    data: data
                });
        }

        function saveColumnFilter(browseId, browse, data, field)
        {
            var sortDirection = skyward.controls.getValue($(".js-saveColumnFilterSort"));
            var boolFilterValue = skyward.controls.getValue($(".js-saveBoolFilterSort"));
            var dataType = $("#filterSection").data("data-type");
            var filterData = {};
            var sortData = sortDirection === "null" ? null : sortDirection === "descending";

            var filterType;
            if (boolFilterValue.length)
            {
                filterType = "bool";
                filterData.TrueOnly = boolFilterValue === "trueOnly" ? true : boolFilterValue === "falseOnly" ? false : null;
                filterData.FilterType = filterData.TrueOnly !== null ? "selection" : "none";
            }
            else
            {
                filterType = dataType === "Enumeration" ? "selection" : skyward.controls.getValue($("#rangeOrSelect"));
                filterData.FilterType = filterType;
            }

            if (filterType === "range")
            {
                var rangeLowElement = $("#txtLowRange");
                var rangeHighElement = $("#txtHighRange");

                filterData.RangeLow = skyward.controls.getValue(rangeLowElement);
                filterData.RangeHigh = skyward.controls.getValue(rangeHighElement);

                if (skyward.time.isDate(filterData.RangeLow, false))
                {
                    filterData.RangeLow = skyward.time.formatServerDate(filterData.RangeLow);
                }
                if (skyward.time.isDate(filterData.RangeHigh, false))
                {
                    filterData.RangeHigh = skyward.time.formatServerDate(filterData.RangeHigh);
                }
            }
            if (filterType === "selection")
            {
                var dmsElement = $("#selectFilterSection .dmsBackingData");
                var dmsData = skyward.controls.getValue(dmsElement);
                filterData.DmsJson = JSON.stringify(dmsData).replaceAll(new RegExp(/(\\+r\\+n)/, "g"), "\\r\\n");
            }

            var filter = {};
            filter[field] = filterData;
            data.filter = JSON.stringify(filter);
            var sort = {};
            sort[field] = sortData;
            data.sort = JSON.stringify(sort);

            var action;
            if (browse.data.browseViewEditorHash)
            {
                action = "UpdateBrowseViewEditorView";
                data.postData = JSON.stringify(browse.data);
            }
            else
            {
                action = "UpdateFilterAndView";
            }

            return requestBrowse(browseId, browse, data, action);
        }

        function performSearch(browseId, browseData)
        {
            var browse = getBrowseByName(browseId);

            if (!browse)
            {
                return;
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.seekId = -1;

            return requestBrowse(browseId, browse, data, "PerformBrowseSearch");
        }

        function initActiveBrowseClass(selector)
        {
            if ($(selector).hasClass("browse"))
            {
                updateActiveBrowseClasses();
            }
        }

        function initSortableColumns(selector)
        {
            $(selector).find(".js-allowColumnSort").each(function ()
            {
                var header = $(this);
                var sortableItems = header.find(".browseHeaderDraggable");

                if (sortableItems.length <= 1)
                {
                    return;
                }

                var browseHeaderContainer = header.closest(".browseHeader");
                var browseBodyContainer = browseHeaderContainer.siblings(".browseBody");
                var lockedBrowseBody = browseBodyContainer.find(".lockedBrowseBody");
                var unlockedBrowseBody = browseBodyContainer.find(".unlockedBrowseBody");

                var locked = header.hasClass("lockedHeaderTableRow");

                var unlockedHeader = locked ? browseHeaderContainer.find(".unlockedHeaderTableRow") : header;

                var fieldIndexToColumns = {};

                for (var siIndex = 0; siIndex < sortableItems.length; siIndex++)
                {
                    var currentFieldIndex = $(sortableItems[siIndex]).data().columnIndex;
                    var fieldIndexSelector = "[data-column-index='" + currentFieldIndex + "']";
                    var groupedItems = sortableItems.filter(fieldIndexSelector);
                    var itemsToWrap = sortableItems.filter(fieldIndexSelector);

                    var startingIndex = itemsToWrap.first().data().columnIndex;
                    var endingIndex = itemsToWrap.last().data().columnIndex;
                    fieldIndexToColumns[currentFieldIndex] =
                    {
                        startingIndex: startingIndex,
                        endingIndex: endingIndex
                    };

                    // Wrap Group Columns in td to allow them to sort together
                    if (groupedItems.length > 1)
                    {
                        var wrapper = $("<td/>",
                            {
                                "class": "browseHeaderDraggable groupColumnWrapper",
                                data:
                                {
                                    columnIndex: currentFieldIndex,
                                    groupColumn: true,
                                    numberOfColumns: itemsToWrap.length
                                }
                            });

                        itemsToWrap.replaceTagNames("div");
                        itemsToWrap.wrapAll(wrapper);
                        siIndex += groupedItems.length - 1;
                    }
                }

                var removeBodyPlaceholder = function (body)
                {
                    body.find(".browseBodySortablePlaceholder").remove();
                };
                var buildColumnSelector = function (fieldIndexToColumn)
                {
                    var dataSelectors = [];
                    for (var i = fieldIndexToColumn.startingIndex; i <= fieldIndexToColumn.endingIndex; i++)
                    {
                        dataSelectors.push(".browseDataCell[data-column='" + i + "']");
                    }
                    return dataSelectors.join(", ");
                };
                var getCellsByFieldIndex = function (fieldIndex, body)
                {
                    var rows = body.find(".browseRow");
                    var columns = fieldIndexToColumns[fieldIndex];
                    var cells = rows.find(buildColumnSelector(columns));
                    return cells;
                };
                var hideColumn = function (fieldIndex, body)
                {
                    var cells = getCellsByFieldIndex(fieldIndex, body);
                    cells.addClass("columnDragging");
                };
                var insertBodyPlaceholder = function (fieldIndex, body, ui, insertAfter)
                {
                    var columns = fieldIndexToColumns[fieldIndex];
                    var placeholder = ui.placeholder.clone().addClass("browseBodySortablePlaceholder");
                    body.find(".browseRow").each(function ()
                    {
                        var cells = $(this).find(".browseDataCell[data-column='" + columns.endingIndex + "']");

                        if (insertAfter)
                        {
                            cells.last().after(placeholder.clone());
                        }
                        else
                        {
                            cells.first().before(placeholder.clone());
                        }
                    });
                };
                var removeUnlockedHeaderPlaceholder = function ()
                {
                    unlockedHeader.find(".browseHeaderDraggablePlaceholder").remove();
                };
                var insertUnlockedHeaderPlaceholder = function (fieldIndex, ui, insertAfter)
                {
                    var sibling = unlockedHeader.find("[data-field-index='" + fieldIndex + "']");
                    if (insertAfter)
                    {
                        sibling.after(ui.placeholder.clone().addClass("browseHeaderDraggablePlaceholder"));
                    }
                    else
                    {
                        sibling.before(ui.placeholder.clone().addClass("browseHeaderDraggablePlaceholder"));
                    }
                };
                var hideUnlockedHeaderColumn = function (fieldIndex)
                {
                    unlockedHeader.find("[data-field-index='" + fieldIndex + "']").addClass("columnDragging");
                };
                var startBodyPlaceholder = function (_event, ui)
                {
                    var itemData = ui.item.data();
                    var columnFieldIndex = itemData.columnIndex;

                    if (locked)
                    {
                        hideColumn(columnFieldIndex, lockedBrowseBody);
                        insertBodyPlaceholder(columnFieldIndex, lockedBrowseBody, ui, true);
                        hideUnlockedHeaderColumn(columnFieldIndex);
                        insertUnlockedHeaderPlaceholder(columnFieldIndex, ui, true);
                    }
                    hideColumn(columnFieldIndex, unlockedBrowseBody);
                    insertBodyPlaceholder(columnFieldIndex, unlockedBrowseBody, ui, true);
                };
                var changeBodyPlaceholder = function (_event, ui)
                {
                    var sibling = ui.placeholder.prev(".browseHeaderDraggable");
                    var columnIndexOfSibling;
                    var insertAfter;
                    if (sibling.length > 0)
                    {
                        columnIndexOfSibling = sibling.data().columnIndex;
                        insertAfter = true;
                    }
                    else
                    {
                        sibling = ui.placeholder.next(".browseHeaderDraggable");
                        columnIndexOfSibling = sibling.data().columnIndex;
                        insertAfter = false;
                    }

                    if (locked)
                    {
                        removeBodyPlaceholder(lockedBrowseBody);
                        insertBodyPlaceholder(columnIndexOfSibling, lockedBrowseBody, ui, insertAfter);
                        removeUnlockedHeaderPlaceholder();
                        insertUnlockedHeaderPlaceholder(columnIndexOfSibling, ui, insertAfter);
                    }
                    removeBodyPlaceholder(unlockedBrowseBody);
                    insertBodyPlaceholder(columnIndexOfSibling, unlockedBrowseBody, ui, insertAfter);
                };
                var stopBodyPlaceholder = function ()
                {
                    if (locked)
                    {
                        removeBodyPlaceholder(lockedBrowseBody);
                        lockedBrowseBody.find(".columnDragging").removeClass("columnDragging");
                        removeUnlockedHeaderPlaceholder();
                        unlockedHeader.find(".columnDragging").removeClass("columnDragging");
                    }
                    removeBodyPlaceholder(unlockedBrowseBody);
                    unlockedBrowseBody.find(".columnDragging").removeClass("columnDragging");
                };

                header.sortable(
                    {
                        axis: "x",
                        opacity: 0.7,
                        distance: 15,
                        scroll: false,
                        forcePlaceholderSize: true,
                        items: "> .browseHeaderDraggable",
                        cancel: ".browseColumnFilterMenuLaunch",
                        helper: function (_event, element)
                        {
                            var helper = element.clone();
                            var iconContainer = helper.find(".iconContainerDiv");
                            if (iconContainer && iconContainer.length > 0)
                            {
                                iconContainer.children().remove();
                            }
                            return helper;
                        },
                        placeholder: "browseHeaderColumn browseColumnSortablePlaceHolder",
                        start: function (event, ui)
                        {
                            header.sortable("refreshPositions");
                            startBodyPlaceholder(event, ui);
                        },
                        update: function (_event, ui)
                        {
                            header.sortable("option", "disabled", true);

                            var currentColumn = ui.item;
                            var newPrecedingColumn = ui.item.prev();

                            var currentColumnData = currentColumn.data();
                            var newPrecedingColumnData = newPrecedingColumn.data() || {};

                            var currentColumnIndex = currentColumnData.columnIndex;
                            var newPrecedingColumnIndex = newPrecedingColumnData.columnIndex !== undefined ? newPrecedingColumnData.columnIndex : null;

                            var currentFieldName = currentColumnData.fieldName;
                            var newPrecedingFieldName = newPrecedingColumnData.fieldName !== undefined ? newPrecedingColumnData.fieldName : null;

                            var browseId = header.data().browseId;
                            var browse = getBrowseByName(browseId);

                            var columnFieldName = browse.columnFieldNames.splice(currentColumnIndex, 1)[0];
                            var spliceIndex = newPrecedingColumnIndex !== null ? newPrecedingColumnIndex : -1;
                            if (spliceIndex < currentColumnIndex)
                            {
                                spliceIndex += 1;
                            }
                            browse.columnFieldNames.splice(spliceIndex, 0, columnFieldName);

                            if (browse.totals.container.length)
                            {
                                moveTotalColumns();
                            }

                            var browseData = header.closest(classNames.browse.dot()).data();
                            var data = skyward.browse.getRequiredBrowseData(browse, browseData);

                            var action = "ChangeBrowseColumnOrder";

                            if (browse.data.browseViewEditorHash)
                            {
                                data.postdata = browse.data;
                                action = "ChangeBrowseViewEditorColumnOrder";
                            }

                            data.currentColumnIndex = currentColumnIndex;
                            data.newPrecedingColumnIndex = newPrecedingColumnIndex;

                            data.currentFieldName = currentFieldName;
                            data.newPrecedingFieldName = newPrecedingFieldName;

                            requestBrowse(browseId, browse, data, action);

                            function moveTotalColumns()
                            {
                                var currentTotalColumn = browse.totals.container.find(".browseFooter__totalColumn[data-column='" + currentColumnIndex + "']");
                                var newPrecedingTotalColumn = (newPrecedingColumnIndex !== null
                                    ? browse.totals.container.find(".browseFooter__totalColumn[data-column='" + newPrecedingColumnIndex + "']")
                                    : browse.totals.container.find(".browseFooter__totalButtonsFiller"));

                                newPrecedingTotalColumn.after(currentTotalColumn);

                                if (currentTotalColumn.hasClass("browseFooter__lockedTotalColumn"))
                                {
                                    // clear shadow column in case the moved column was the rightmost locked column, or has taken its place
                                    currentTotalColumn.add(newPrecedingTotalColumn).removeClass("browseFooter__shadowColumn");
                                    browse.totals.container.find(".browseFooter__lockedTotalColumn").last().addClass("browseFooter__shadowColumn");
                                }
                                else
                                {
                                    // clear margin-left in case the moved column was the leftmost unlocked column, or has taken its place
                                    // (updateTotalColumnOffsets will set it again on the appropriate column)
                                    currentTotalColumn.add(currentTotalColumn.next()).css("margin-left", "");
                                }
                                var totalColumns = browse.totals.container.find(".browseFooter__totalColumn,.browseFooter__totalButtonsFiller");
                                updateTotalColumnOffsets(totalColumns, 0);
                            }
                        },
                        change: function (event, ui)
                        {
                            changeBodyPlaceholder(event, ui);
                        },
                        stop: function ()
                        {
                            stopBodyPlaceholder();
                        }
                    });

                // Handle scrolling while sorting in unlocked body
                if (!locked)
                {
                    var scrollableBody = header.closest(classNames.browse.dot()).find(".unlockedBrowseBody");
                    var headerContainer = header.closest(".unlockedHeader");
                    var lockedHeader = headerContainer.siblings(".lockedHeader");
                    var lockedHeaderWidth = 0;
                    if (lockedHeader.length > 0)
                    {
                        lockedHeaderWidth = lockedHeader.width();
                    }
                    var isScrolling = false;
                    var scrollingId;

                    var checkScroll = function (event)
                    {
                        if (headerContainer.length == 0)
                        {
                            return;
                        }
                        var e = event.originalEvent;
                        var left = headerContainer.offset().left + lockedHeaderWidth;
                        var right = left + headerContainer.width() - lockedHeaderWidth;
                        var distance = 0;
                        var multiplier = 1;
                        var padding = 25;

                        if (e.pageX < (left + padding) && e.pageX > (left - padding))
                        {
                            distance = left - (e.pageX - padding);
                            multiplier = -1;
                        }
                        else if (e.pageX < (right + padding) && e.pageX > (right - padding))
                        {
                            distance = e.pageX - (right - padding);
                            multiplier = 1;
                        }

                        if (distance != 0)
                        {
                            var acceleration = 1.75;
                            var accelerationLimiter = 0.1;
                            isScrolling = true;
                            clearTimeout(scrollingId);
                            scroll(Math.pow(Math.abs(distance), acceleration) * accelerationLimiter * multiplier);
                        }
                        else
                        {
                            isScrolling = false;
                        }
                    };
                    var scroll = function (amount)
                    {
                        if (isScrolling)
                        {
                            scrollableBody.scrollLeft(scrollableBody.scrollLeft() + amount);
                            scrollingId = setTimeout(function ()
                            {
                                scroll(amount);
                            }, 10);
                        }
                    };
                    header.on("sort", checkScroll);
                }
            });
        }

        function exportBrowse()
        {
            var clickedElement = $(this);
            var dov = clickedElement.closest(".dataObjectViewer");
            var dialog = {};

            if (dov.length > 0 && skyward.changeTracking.isDirty(dov))
            {
                dialog = skyward.modalLayer.showCriticalDialog("Warning",
                    "<span style=\"font-weight:bold\">Are you sure you want to export without saving?</span>\n" +
                    "Any unsaved changes will not be included in the export.",
                    [
                        { text: "Export without Saving", "icon": "Check", click: doExport },
                        { text: "Cancel", "icon": "Cancel" }
                    ], {});
            }
            else
            {
                doExport();
            }

            function doExport()
            {
                if (typeof dialog.close === "function")
                {
                    dialog.close();
                }
                var tmpUnloadCheck = skyward.window.skipUnloadCheck;
                skyward.window.skipUnloadCheck = true;
                transformBrowse(clickedElement, "GetBrowseExport", { openNewWindow: false, downloadOnMobile: true });
                skyward.window.skipUnloadCheck = tmpUnloadCheck;
            }
        }

        function designReport()
        {
            var clickedElement = $(this);
            transformBrowse(clickedElement, "CreateReportFromBrowse", { openNewWindow: true });
        }

        function showAuditLegend()
        {
            var legendButton = $(this);
            var buildPopup = function ()
            {
                return $.ajax(
                    {
                        url: skyward.global.virtualDir + "SkySys/Browse/AuditBrowseLegend/",
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { hideGlass: true }
                    });
            };
            skyward.modalLayer.showDialog("Legend", buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: legendButton });
        }

        function transformBrowse(button, action, submitMode)
        {
            var browseData = button.data();
            if ($.isEmptyObject(browseData))
            {
                return;
            }

            var browse = getBrowseByName(browseData.browseId);

            if (!browse)
            {
                return;
            }

            var data = $.extend({}, browseData, skyward.browse.getRequiredBrowseData(browse, {}));

            var cols = browse.columnFieldNames.length;
            var excelMaxRows = 1048576;
            var excelMaxCols = 16384;
            var isExcelType = browseData.exportType === "XLSX";

            if (!isExcelType)
            {
                doExport();
                return;
            }
            if (cols === 0)
            {
                skyward.modalLayer.showErrorDialog("Unable to export to XLSX when the list has zero columns.", "Please add columns and try exporting again, or export as a CSV instead.");
            }
            else if (cols > excelMaxCols)
            {
                skyward.modalLayer.showErrorDialog("Unable to export to XLSX when the list has more than " + excelMaxCols.toLocaleString() + " columns.", "Please remove columns and try exporting again, or export as a CSV instead.");
            }
            else
            {
                getBrowseRowCount(browse, data).done(function (rowCount)
                {
                    if (rowCount > excelMaxRows)
                    {
                        skyward.modalLayer.showErrorDialog("Unable to export to XLSX  when the list has more than " + excelMaxRows.toLocaleString() + " rows.", "Please filter the list to reduce the number of rows, or export as a CSV instead.");
                    }
                    else
                    {
                        doExport();
                    }
                });
            }

            function doExport()
            {
                var url = skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + "/" + action;
                skyward.window.submitForm(url, data, submitMode);
            }
        }

        function getBrowseRowCount(browse, data)
        {
            if (browse.rowCount !== null)
            {
                return $.Deferred().resolve(browse.rowCount).promise();
            }
            var deferred = $.Deferred();
            $.ajax(
                {
                    url: skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + "/GetRecordCount",
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    activityIndicator: { hideGlass: true },
                    success: function (data)
                    {
                        browse.rowCount = data.RecordCount;
                        deferred.resolve(browse.rowCount);
                    }
                }
            );
            return deferred.promise();
        }

        function wireUpExpandCollapseBrowseButton(browse)
        {
            var body = $(document.body);
            var browseId = browse.attr("id");
            browse.find(".js-expandCollapseBrowsePanel").each(function ()
            {
                var collapseButton = $(this);
                var collapsibleContainer = collapseButton.closest(".bottomCollapsibleBrowseContainer");
                var primaryBrowseContainer = collapsibleContainer.siblings(".topExpandableBrowseContainer");
                var primaryBrowse = primaryBrowseContainer.find(classNames.browse.dot());
                var primaryBrowseId = primaryBrowse.attr("id");

                function ExpandCollapseBrowse(_event, browsesAreReturningToNormalHeight)
                {
                    if (collapsibleContainer.length > 0)
                    {
                        var mainSelectedBrowse = collapsibleContainer.find(classNames.mainSelectedBrowse.dot());
                        if (mainSelectedBrowse.length > 0)
                        {
                            var prevBrowseId = collapsibleContainer.prev().find(".browse").first().attr("id");
                            var browse = getBrowseByName(prevBrowseId);
                            if (browse)
                            {
                                var options =
                                {
                                    loadRelatedBrowses: false,
                                    updateBrowseSeekInfo: false,
                                    setCurrentBrowseName: true
                                };
                                skyward.browse.setCurrentRecord(prevBrowseId, browse.currentRow, options);
                            }
                        }
                        AnimateBrowseExpandCollapse(browsesAreReturningToNormalHeight);
                    }
                }

                function collapseButtonOnClick()
                {
                    collapseButton.on("click", function ()
                    {
                        var browsesAreReturningToNormalHeight = collapsibleContainer.hasClass("bottomBrowsesCollapsed");
                        skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                        {
                            if (wasDirty)
                            {
                                skyward.window.skipUnloadCheck = true;
                            }
                            updateCollapsibleBrowseState(browsesAreReturningToNormalHeight);
                            body.trigger("BrowseExpandCollapseEvent", browsesAreReturningToNormalHeight);
                            toggleCollapseButton(collapseButton, browsesAreReturningToNormalHeight);
                        });
                    });
                }

                function AnimateBrowseExpandCollapse(browsesAreReturningToNormalHeight)
                {
                    collapseButton.off("click");

                    var primaryBrowseAnimation;
                    var collapsibleContainerAnimation;
                    if (browsesAreReturningToNormalHeight)
                    {
                        primaryBrowseAnimation = primaryBrowseContainer.switchClass("topBrowseExpanded", "topBrowseNormalHeight", "fast").promise();
                        collapsibleContainerAnimation = collapsibleContainer.switchClass("bottomBrowsesCollapsed", "bottomBrowsesNormalHeight", "fast", function ()
                        {
                            $(window).trigger("resize"); //reflow responsive controls
                        }).promise();
                    }
                    else
                    {
                        primaryBrowseAnimation = primaryBrowseContainer.switchClass("topBrowseNormalHeight", "topBrowseExpanded", "fast").promise();
                        collapsibleContainerAnimation = collapsibleContainer.switchClass("bottomBrowsesNormalHeight", "bottomBrowsesCollapsed", "fast", function ()
                        {
                            if (collapsibleContainer.find(classNames.selectedDetailsRow.dot()).length > 0)
                            {
                                browseDetailsPanel.refreshDetailsPanel(primaryBrowseId);
                            }
                        }).promise();
                    }

                    var onAnimationDone = function (collapsibleContainer)
                    {
                        collapsibleContainer.css("overflow", "");
                        collapseButtonOnClick();
                        skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar(getBrowseByName(primaryBrowseId));
                        scrollTopBrowseRowIntoView();
                    };

                    $.when(primaryBrowseAnimation, collapsibleContainerAnimation).done(function () { onAnimationDone(collapsibleContainer); });
                }

                function scrollTopBrowseRowIntoView()
                {
                    var topBrowseHasCurrentSelectedRow = primaryBrowse.find(".lockedBrowseBody .current, .unlockedBrowseBody .current");
                    if (topBrowseHasCurrentSelectedRow.length !== 0)
                    {
                        topBrowseHasCurrentSelectedRow.each(function () { this.scrollIntoView(); });
                    }
                }

                function updateCollapsibleBrowseState(isNormalHeight)
                {
                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "SkySys/Browse/UpdateCollapsibleBrowseState",
                            type: "POST",
                            dataType: "JSON",
                            activityIndicator: { hideGlass: true },
                            data:
                            {
                                IsNormalHeight: isNormalHeight
                            }
                        }
                    );
                }

                body.off("BrowseExpandCollapseEvent." + browseId);
                body.on("BrowseExpandCollapseEvent." + browseId, ExpandCollapseBrowse);

                collapseButtonOnClick();
            });

            function toggleCollapseButton(button, expand)
            {
                button.find("svg").replaceWith(skyward.svg.getSvg(expand ? "ChevronDown" : "ChevronUp", "BrowseExpandCollapse"));
            }
        }

        function initMobileBrowse(containerDiv, dataHtml, browse)
        {
            /* don't process the mobile browse data if there is no data, the data is an input, or if we have already processed the data */
            if (!dataHtml || dataHtml.indexOf("<input") === 0 || containerDiv.find("." + mobileBrowseClasses.mobileBrowseBody).length)
            {
                return Promise.resolve();
            }

            var placeholder;

            if (!containerDiv.is(":visible"))
            {
                placeholder = $("<div>", { css: { display: "none" } });
                placeholder.insertBefore(containerDiv);
                containerDiv.appendTo(document.body);
            }

            resetContainer();

            const scriptsLoadedPromise = initializeMobileBrowseData();

            // Apply carried-over totals before calling applyMobileLockedColumn.
            // Without this we would have to call it again in finishRegistration.
            if (browse.totals !== undefined && browse.totals.data !== undefined)
            {
                displayBrowseTotals(browse, containerDiv.find(".browseFooter__totalsSection"));
            }

            var browseBody = containerDiv.find(classNames.browseBody.dot());
            var unlockedBrowseBody = containerDiv.find(classNames.unlockedBrowseBody.dot());

            browseBody.addClass(mobileBrowseClasses.mobileBrowseBody);

            removeFirstColumnIfEmpty();

            combineRowIcons();

            skyward.browse.applyMobileLockedColumn(containerDiv, browseBody, unlockedBrowseBody);

            setEvents();

            if (placeholder)
            {
                containerDiv.insertAfter(placeholder);
                placeholder.remove();
            }

            return scriptsLoadedPromise;

            function initializeMobileBrowseData()
            {
                //remove widths from browse data
                const { html: processedHtml, scriptsLoaded: scriptsLoadedPromise } = skyward.global.processScriptsAndHtmlSeparately(skyward.browse.prepMobileBrowseData(dataHtml));
                var dataFragment = $("<div>").append(processedHtml);

                //remove unwanted browse elements 
                dataFragment.find("#browse_lockedHeader,.lockedBrowseBody_scrollwrapper,.browseHeaderSpacer").remove();

                //remove header if there is only one browse or is explicitly hidden in mobile
                var activeBrowses = skyward.window.getClosestContentPanel(containerDiv).find(classNames.browse.dot());
                if (activeBrowses.length <= 1 || containerDiv.hasClass('hideHeaderMobile'))
                {
                    dataFragment.find(".browse__sectionHeader").closest(".containerToolbar").remove();
                }

                //add the header row to the browse body within a thead
                $("<thead>" + dataFragment.find(".unlockedHeader tbody").html() + "</thead>").insertBefore(dataFragment.find(".js-appendMobileBrowseHeader"));
                var totalsSection = dataFragment.find(".browseFooter__totalsSection");
                if (totalsSection.length)
                {
                    var footer = $("<tfoot>", { class: totalsSection.attr("class") });
                    footer.append(totalsSection.find("tr").clone()).insertAfter(dataFragment.find(".js-appendMobileBrowseFooter"));
                }

                containerDiv.addClass(mobileBrowseClasses.mobileBrowseContainer);
                containerDiv.append(dataFragment.children());
                return scriptsLoadedPromise;
            }

            function resetContainer()
            {
                containerDiv.html("");
                containerDiv.removeClass([mobileBrowseClasses.mobileBrowseContainer, mobileBrowseClasses.hasHeaderShadow, mobileBrowseClasses.hasColumnShadow].join(" "));
            }

            function removeFirstColumnIfEmpty()
            {
                var table = unlockedBrowseBody.find(".unlockedBrowseTable")[0];
                if (!table)
                {
                    return;
                }
                var firstColumnCells = [];
                var anyCellHasContent = false;
                Array.from(table.rows).some(function (row)
                {
                    var cell = $(row.cells[0]);

                    if (checkIfCellHasContent(cell))
                    {
                        anyCellHasContent = true;
                    }
                    else
                    {
                        firstColumnCells.push(cell);
                    }
                    return anyCellHasContent;
                });

                if (!anyCellHasContent)
                {
                    // if the first column of the unlocked table is removed, also remove the first column from the locked table
                    var headerTable = containerDiv.find(".browseHeader > .unlockedHeader > table")[0];
                    if (headerTable !== undefined && headerTable.rows.length > 0 && headerTable.rows[0].cells.length > 0)
                    {
                        firstColumnCells.push($(headerTable.rows[0].cells[0]));
                    }

                    firstColumnCells.map(function (cell)
                    {
                        cell.remove();
                    });
                }

                function checkIfCellHasContent(cell)
                {
                    var contentTags = "svg,img,:input:not([type=hidden])";
                    return cell.length && (cell.text().trim().length || cell.find(contentTags).length);
                }
            }

            function combineRowIcons()
            {
                /* remove new window links in mobile */
                unlockedBrowseBody.find(".svg.newWindow").each(function ()
                {
                    $(this).closest(".svgAnchor").remove();
                });

                /* combine row icons into the more icon */
                unlockedBrowseBody.find("svg.rowAction").each(function ()
                {
                    var rowActionLink = $(this).parent(".svgAnchor");
                    if (!rowActionLink.length)
                    {
                        return;
                    }
                    var onClickStr = rowActionLink.attr("onclick");
                    rowActionLink.closest("td").find(".svgAnchor").not(rowActionLink).each(function ()
                    {
                        var button = $(this);
                        var buttonId = this.id;
                        var iconHref = button.find("use").attr("xlink:href");
                        var icon = /#svg-(\w+)/.exec(iconHref)?.[1];
                        var text = button.find(".anchorText").text();
                        if (text == "")
                        {
                            switch (icon)
                            {
                                case "RowOpen": text = "Details";
                                    break;
                                case "RunReport": text = "Run Report";
                                    break;
                                case "Info": text = "Info";
                                    break;
                                default: text = icon;
                                    break;
                            }
                        }
                        var menuOption =
                        {
                            text: text,
                            icon: icon,
                            data: { "click-target-id": buttonId }
                        };
                        onClickStr = onClickStr.replace("skyward.browse.rowPopupMenu([", "skyward.browse.rowPopupMenu([" + JSON.stringify(menuOption) + ",");
                        button.hide();
                    });
                    rowActionLink.attr("onclick", onClickStr);
                });
            }

            function applyBoxShadowCss(hasShadowClass, scrollValue, containerDiv)
            {
                if (scrollValue > 0)
                {
                    if (!containerDiv.hasClass(hasShadowClass))
                    {
                        containerDiv.css("willChange", "box-shadow");
                        containerDiv.addClass(hasShadowClass);
                        containerDiv.css("willChange", "");
                    }
                }
                else if (containerDiv.hasClass(hasShadowClass))
                {
                    containerDiv.css("willChange", "box-shadow");
                    containerDiv.removeClass(hasShadowClass);
                    containerDiv.css("willChange", "");
                }
            }

            function setEvents()
            {
                /* scroll in the X direction */
                unlockedBrowseBody.on("scroll", function (eventData)
                {
                    applyBoxShadowCss(mobileBrowseClasses.hasColumnShadow, this.scrollLeft, containerDiv);
                });

                /* scroll in the Y direction */
                browseBody.on("scroll", function (eventData)
                {
                    applyBoxShadowCss(mobileBrowseClasses.hasHeaderShadow, this.scrollTop, containerDiv);
                });

                /* this fixes an issue in iOS where scrolling breaks after an orientation change */
                $(window).on("orientationchange", function (_event)
                {
                    $(document.body).addClass("translateZ");
                    window.setTimeout(function ()
                    {
                        $(document.body).removeClass("translateZ");
                    }, 10);
                });

                /* add click events to the header elements (one in the browseBody, the other in the fixed browseHeader). */
                /* Don't bind events to just the containerDiv, it is reused if the browse is reloaded. */
                /* Using delegated click events here allows us to bind a total of 2 listeners.  If we bound to the browseHeaderColumn elements we would have 2X more listeners than browse columns. */
                $().add(browseBody.find(".unlockedHeaderTableRow")).add(containerDiv.find(".browseHeader")).on("click", ".browseHeaderColumn", function ()
                {
                    var td = $(this);
                    var cog = td.find(".browseColumnFilterMenuLaunch");
                    if (cog.length)
                    {
                        browseHeaderColumnClick.apply(cog);
                        return;
                    }
                    var sort = td.find(".browseColumnHeaderSort");
                    if (sort.length)
                    {
                        changeSort.apply(sort);
                        return;
                    }
                });

                /* simulate momentum scrolling on the fixed browse header */
                containerDiv.find(".unlockedHeader").swipe(
                    {
                        preventDefaultEvents: false,
                        swipeStatus: function (_event, phase, direction, distance, duration, fingerCount)
                        {
                            if (direction === "right")
                            {
                                distance = distance * -1;
                            }

                            switch (phase)
                            {
                                case "start":
                                    window.browseHeaderScrollData =
                                    {
                                        origScroll: unlockedBrowseBody.stop().scrollLeft(),
                                        isScrollable: unlockedBrowseBody.is(":scrollable"),
                                        distances: [],
                                        times: []
                                    };
                                    break;
                                case "move":
                                    if (direction !== "right" && direction !== "left")
                                    {
                                        return;
                                    }
                                    if (!window.browseHeaderScrollData.isScrollable)
                                    {
                                        return;
                                    }
                                    unlockedBrowseBody.scrollLeft(window.browseHeaderScrollData.origScroll + distance);
                                    window.cancelTouchSwipe = true; //prevent menu from opening;
                                    addShiftValue(window.browseHeaderScrollData.distances, distance);
                                    addShiftValue(window.browseHeaderScrollData.times, new Date().getTime());
                                    break;
                                case "end":
                                case "cancel":
                                    unlockedBrowseBody.on("touchstart", interruptFinishScroll);
                                    var momentumScrollDistance = getMomentumScrollDistance(window.browseHeaderScrollData.distances, window.browseHeaderScrollData.times);
                                    if (momentumScrollDistance !== 0)
                                    {
                                        unlockedBrowseBody.stop().animate({ scrollLeft: (unlockedBrowseBody.scrollLeft() + momentumScrollDistance) }, 800, "easeOutExpo", function ()
                                        {
                                            unlockedBrowseBody.off("touchstart", interruptFinishScroll);
                                        });
                                    }
                                    break;
                            }

                            function interruptFinishScroll()
                            {
                                unlockedBrowseBody.stop();
                            }

                            function addShiftValue(array, val)
                            {
                                if (array.length > 1)
                                {
                                    array.shift();
                                }
                                array.push(val);
                            }

                            function getMomentumScrollDistance(distances, times)
                            {
                                var scrollDistance = 0;
                                if (distances.length === 2 && times.length === 2)
                                {
                                    var deltaDistance = distances[1] - distances[0];
                                    var deltaTime = times[1] - times[0];
                                    var deltaDistOverTime = deltaDistance / deltaTime;
                                    var scrollFactor = 150;

                                    scrollDistance = Math.min(scrollFactor * 4, deltaDistOverTime * scrollFactor) || 0;
                                }

                                return scrollDistance;
                            }
                        }
                    });
            }
        }

        function getBrowseType(browse)
        {
            var browseTypeData =
            {
                browseType: browse.browseType
            };

            if (browse.browseType == "MultiSelect")
            {
                $.extend(browseTypeData, skyward.multiselectbrowse.getData(browse.browseName));
            }
            else if (browse.browseType == "Editable")
            {
                $.extend(browseTypeData, skyward.editablebrowse.getData(browse));
            }
            else if (browse.browseType == "DistinctMultiSelect")
            {
                $.extend(browseTypeData, skyward.distinctmultiselecteel.getData(browse));
            }
            else if (browse.browseType == "Checkbox")
            {
                $.extend(browseTypeData, skyward.checkboxbrowse.getData(browse));
            }

            return browseTypeData;
        }

        function getRelatedBrowse(browseName, isParentEmpty, rowData, rowDataHash, row, parentKey)
        {
            var browse = getBrowseByName(browseName);

            if (browse === undefined)
            {
                return $.Deferred().reject().promise();
            }

            const browseExistsOnPage = browse.browse && browse.browse.length > 0 && $.contains(document, browse.browse[0]);

            if (!browseExistsOnPage)
            {
                return $.Deferred().reject().promise();
            }

            //Set rowData to an empty string to prevent it from getting the default browse rowData later.  
            //Empty rowData strings get deleted from postData in getRequiredBrowseData
            if (row === null || row < 0)
            {
                browse.data.rowData = "";
            }
            else 
            {
                var rowDataToPost = {};
                for (var key in rowData)
                {
                    rowDataToPost[key] = rowData[key][row];
                }
                if (!$.isEmptyObject(rowDataToPost))
                {
                    browse.data.rowData = JSON.stringify(rowDataToPost);
                    browse.data.rowDataHash = rowDataHash[row];
                }
            }

            if (browse.totals && browse.totals.container.length)
            {
                browse.totals.data = undefined;
                if (browse.totals.ajaxRequest !== undefined)
                {
                    browse.totals.ajaxRequest.abort();
                    browse.totals.ajaxRequest = undefined;
                }
            }

            var data =
            {
                seekId: -1,
                pagingType: "FirstPage",
                isRelatedBrowse: "true",
                hidePrimaryBrowseButton: isParentEmpty,
                parentPrimaryKeyID: parentKey
            };

            return skyward.browse.get(browseName, data);
        }

        function shouldProcessMobileBrowse(browse)
        {
            var shouldProcess = skyward.global.mobileAccess;
            if (browse)
            {
                var browseDiv = browse.browse || $("#" + browse.id);
                if (browse.browseType === "Tile" || (browseDiv.length && browseDiv.is("[data-skip-mobile-processing]")))
                {
                    shouldProcess = false;
                }
            }
            return shouldProcess;
        }

        function requestBrowse(browseId, browse, browseData, action, options)
        {
            if (!browse)
            {
                return $.Deferred().reject().promise();
            }

            var browseLoaded = $.Deferred();
            if (skyward.browse.isInWorkflow(browse))
            {
                skyward.workflow.addDisableNavigationPromise(browseLoaded);
            }

            var browseIsCodeEEL = browseData.codeEelName != null;
            var loadingNewDetailsPanel = !browseIsCodeEEL && browseDetailsPanel.currentDetailsBrowse === browseData.browseName || browse.relatedBrowses && browse.relatedBrowses.includes(skyward.browse.getCurrentBrowseName());

            if (loadingNewDetailsPanel)
            {
                return skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                {
                    if (wasDirty)
                    {
                        skyward.window.skipUnloadCheck = true;
                    }
                    return doRequest();
                });
            }

            return doRequest();

            function doRequest()
            {
                //if the browse has been rendered before, its primary button will know what control it should modify, pass that info along to persist it
                if (browse.currentRow != null)
                {
                    //Make sure that the button exists & has data before attempting to use the value.
                    var newButton = $("#" + browseId + "_newButton");
                    if (newButton.length > 0)
                    {
                        var buttonData = newButton.data();
                        if (!$.isEmptyObject(buttonData))
                        {
                            browseData.pageStateControlValues = JSON.stringify(buttonData);
                        }
                    }
                }

                var localStopwatch = skyward.time.stopwatch();
                var totalStopwatch = skyward.time.stopwatch();

                if (!browse.timestamp)
                {
                    browse.timestamp = 0;
                }
                var repeater = browse.browse ? browse.browse.closest(".repeater") : $();

                if (repeater.length)
                {
                    var renderedBrowses = repeater.data("renderedBrowses") || {};
                    if (!renderedBrowses[browse.browseIDHash])
                    {
                        renderedBrowses[browse.browseIDHash] = true;
                        repeater.data("renderedBrowses", renderedBrowses);
                    }
                    else
                    {
                        browseData.isRepeatedBrowse = true;
                    }
                }                

                var routeModule = !$.isEmptyObject(options) && options.moduleOverride ? options.moduleOverride : browse.browseModule;
                var routeObject = !$.isEmptyObject(options) && options.objectOverride ? options.objectOverride : browse.browseObject;

                var url = skyward.global.virtualDir + routeModule + "/" + routeObject + "/" + action;

                // if we can find the browse in the detailsPreview container then we want to hide the button in the details we are opening
                browseData.hidePreviewDetailsButton = browse.hidePreviewDetailsButton || skyward.detailsPanel.containsElement(browse.browse);
                browseData.detailsPanelType = browse.detailsPanelType;

                var requestStopwatch = skyward.time.stopwatch();

                var browseRequest = $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "JSON",
                        data: browseData,
                        activityIndicator: { hideGlass: true },
                        success: function (data)
                        {
                            var totalActionTime = requestStopwatch.duration();
                            if (data === undefined)
                            {
                                skyward.error.reportException(new window.SkywardException("Browse response data was undefined"));
                                return;
                            }

                            if (data.usageHistoryID)
                            {
                                skyward.performanceMonitor.completePerformanceMonitoring(data.usageHistoryID, totalActionTime);
                            }
                            var downloadTime = localStopwatch.duration();

                            var div = $("#" + browse.id);

                            // Remove any skyVue instances that are in the div to trigger Vue deregistration
                            div.find(".js-skyVue").remove();

                            // Don't add the browse to the DOM until the document is ready, so our skyward.window.notifyDOMLoad()
                            // won't interfere with the one fired when the document loads
                            $(function ()
                            {
                                //since requests are async, make sure to always display the most recently requested browse
                                if (data.timestamp > browse.timestamp)
                                {
                                    browse.timestamp = data.timestamp;

                                    localStopwatch.restart();

                                    
                                    if (div.length < 1)
                                    {
                                        return;
                                    }

                                    if (shouldProcessMobileBrowse(browse))
                                    {
                                        div.empty();
                                        initMobileBrowse(div, data.html, browse).then(() =>
                                        {
                                            div.attr("aria-label", browse.displayName);
                                            browseLoaded.resolve();
                                        });
                                    }
                                    else
                                    {
                                        skyward.global.processScriptHtml(data.html).done(function (html)
                                        {
                                            var sectionHeaderTag = $(html).find(".sectionHeader__text");
                                            if (sectionHeaderTag.length > 0)
                                            {
                                                browse.displayName = sectionHeaderTag[0].textContent;
                                                var existingAriaLabbeledBy = div.attr("aria-labelledby"); // Browses that are within a template within a repeater might add its own label
                                                existingAriaLabbeledBy !== undefined ? div.attr("aria-labelledby", `${existingAriaLabbeledBy} ${sectionHeaderTag.attr("id")}`) :
                                                    div.attr("aria-labelledby", sectionHeaderTag.attr("id"));
                                            }
                                            else
                                            {
                                                // Browse is not a major region with its own title
                                                div.removeAttr("role");
                                            }

                                            div.html(html);
                                            browseLoaded.resolve();
                                        });
                                    }
                                    browseLoaded.done(function ()
                                    {
                                        browseLoadedSuccess(browse, data, localStopwatch, totalStopwatch, downloadTime, doRequest);
                                    });
                                }
                                else
                                {
                                    browseLoaded.resolve();
                                }

                                if (typeof browse.successCallback === "function")
                                {
                                    browseLoaded.done(function ()
                                    {
                                        browse.successCallback();
                                    });
                                }

                                // If this is a GetBrowse request, and the getBrowseSearchMode flag is AfterRequest, then perform the search after the GetBrowse request is complete
                                if (browseData.getBrowseSearchMode === "AfterRequest" && action === "GetBrowse")
                                {
                                    browseLoaded.done(function ()
                                    {
                                        performSearch(browseId, browseData);
                                    });
                                }

                                browseLoaded.done(() =>
                                {
                                    $(window).trigger("resize"); // reflow responsive controls
                                });
                            });
                        }
                    }
                );

                skyward.browseLoadTimer.monitorRequest(browseRequest, browse, browseData, routeModule, routeObject, action);

                // Disposing of the old browse html can be expensive, so do it now, while the ajax request is in flight
                if (browse.body)
                {
                    browse.body.html("<div class=\"browseBodyLoading\">" + skyward.window.getImageHtml("getRecordCountPageLoadingGif") + " Loading...</div>");
                    browse.totals.container.addClass("browseFooter__totalsSection--notReady");
                    // Clean up header widgets now, otherwise they will need to be cleaned by the call to .html() in the success callback
                    // Based on https://github.com/jquery/jquery/blob/0ec25a/src/manipulation.js#L423
                    $.cleanData(browse.browse[0].getElementsByTagName("*"));
                    browse.contentMessageArea = undefined;
                }

                if (loadingNewDetailsPanel)
                {
                    skyward.detailsPanel.emptyDetailsPanel();
                }

                // we need to return the whole ajax request here, not just the promise, since some callers may want to abort the request.
                return browseRequest;
            }
        }

        function setupDependency(browse)
        {
            if (browse.browse.data("dependency"))
            {
                $.each(browse.browse.data("dependency").dependencyItems, function ()
                {
                    var control = $("#" + this.ControlID);
                    var itemDependents = control.data("dependents");
                    var dependentData = { Id: browse.browseName };

                    if (!itemDependents)
                    {
                        itemDependents = { dependents: [dependentData] };
                    }
                    else if (!itemDependents.dependents.some(function (dependent) { return dependent.Id == browse.browseName; }))
                    {
                        itemDependents.dependents.push(dependentData);
                    }

                    control.data("dependents", itemDependents);
                });
            }
        }

        function updateBrowseTotalsRequest(browse)
        {
            if (browse.totals.container.length)
            {
                requestBrowseTotals(browse);
            }
            else
            {
                if (browse.totals.ajaxRequest !== undefined)
                {
                    browse.totals.ajaxRequest.abort();
                    browse.totals.ajaxRequest = undefined;
                }
                if (browse.totals.nextTimeoutId !== undefined)
                {
                    clearTimeout(browse.totals.nextTimeoutId);
                    browse.totals.nextTimeoutId = undefined;
                }
            }
        }

        function getBrowseTotals(browse)
        {
            return $.ajax(
                {
                    url: skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + "/GetBrowseTotals",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { hideGlass: true },
                    data: skyward.browse.getRequiredBrowseData(browse)
                });
        }

        function requestBrowseTotals(browse)
        {
            var debounceSeconds = 3;
            // we want to send the first request asap
            // subsequent changes are deferred for debounceSeconds
            if (browse.totals.nextTimeoutId !== undefined || browse.totals.ajaxRequest !== undefined)
            {
                return;
            }
            var timeout = browse.totals.nextRequestTime === undefined ? 0 : (browse.totals.nextRequestTime - new Date());
            browse.totals.nextTimeoutId = setTimeout(function ()
            {
                browse.totals.nextTimeoutId = undefined;
                browse.totals.ajaxRequest = getBrowseTotals(browse);
                browse.totals.ajaxRequest.then(function (data)
                {
                    // finish debouncing - don't include request time
                    browse.totals.ajaxRequest = undefined;
                    var nextTotalRequestTime = new Date();
                    nextTotalRequestTime.setSeconds(nextTotalRequestTime.getSeconds() + debounceSeconds);
                    browse.totals.nextRequestTime = nextTotalRequestTime;

                    var oldData = browse.totals.data;
                    browse.totals.data = data;

                    displayBrowseTotals(browse);
                    updateMobileTotalColumnWidths(browse, oldData, data);
                });
            }, timeout);
        }

        function displayBrowseTotals(browse, newBrowseContainer)
        {
            var container = newBrowseContainer || browse.totals.container;
            var data = browse.totals.data;
            if (data !== undefined)
            {
                var columns = container.find(".browseFooter__totalColumn.js-browseFooter__totalColumn--hasData");
                for (var i = 0; i < columns.length; i++)
                {
                    var column = columns.eq(i);
                    var displayColumnIndex = parseInt(column.attr("data-display-column"));
                    column.text(data[browse.columnFieldNames[displayColumnIndex]]);
                }
            }
            if (browse.totals.nextTimeoutId === undefined)
            {
                container.removeClass("browseFooter__totalsSection--notReady");
            }
        }

        function updateMobileTotalColumnWidths(browse, oldData, newData)
        {
            if (!shouldProcessMobileBrowse(browse))
            {
                return;
            }
            if (oldData && newData && oldData.length === newData.length &&
                Object.keys(newData).every(function (key) { return oldData[key] === newData[key]; }))
            {
                return;
            }
            skyward.browse.applyMobileLockedColumn(browse.browse);
        }

        function getParentBrowse(browse)
        {
            for (const [browseName, browseObject] of Object.entries(skyward.browse.browseList))
            {
                if (!$.isEmptyObject(browseObject.relatedBrowses) && browseObject.relatedBrowses.find(relatedBrowse => relatedBrowse.BrowseID === browse.id))
                {
                    return browseObject;
                }
            }
            return undefined;
        }

        function getHeaderNumber(browse)
        {
            const defaultHeaderNumber = 2;

            if (!browse.browse)
            {
                return defaultHeaderNumber;
            }

            let headerNumber;

            const parentBrowse = getParentBrowse(browse);

            if (parentBrowse)
            {
                headerNumber = skyward.browse.getRequiredBrowseData(parentBrowse).headerNumber + 1;
            }
            else
            {
                headerNumber = defaultHeaderNumber;
                if (browse.browse.closest(".contentArea").find(".js-hasInitialHeader").length)
                {
                    headerNumber++;
                }
            }
            return headerNumber;
        }

        function updateTotalColumnOffsets(elements, left)
        {
            var accum = [left];
            var element;
            for (var i = 0; i < elements.length; i++)
            {
                element = elements[i];
                if (element.classList.contains("browseFooter__lockedTotalColumn"))
                {
                    left += parseFloat(element.style.width);
                    accum.push(left);
                }
                else
                {
                    break;
                }
            }
            for (i = 0; i < accum.length - 1; i++)
            {
                element = elements[i];
                element.style.left = accum[i] + "px";
            }
            elements[accum.length - 1].style.marginLeft = accum[accum.length - 1] + "px";
        }

        function getMainSelectedBrowse()
        {
            var browseElement = $(classNames.modalLayerContainer.dot()).last().find(classNames.mainSelectedBrowse.dot()).add("#master " + classNames.mainSelectedBrowse.dot()).first();
            return skyward.browse.getContainingBrowse(browseElement);
        }

        function gatherDataForError()
        {
            var browses = {};
            for (var browseId in skyward.browse.browseList)
            {
                var browse = getBrowseByName(browseId);
                browses[browseId] =
                {
                    title: skyward.browse.getDebugName(browse),
                    attached: !!document.getElementById(browseId)
                };
            }

            return { browses: browses, detailsPanelOpen: !!browseDetailsPanel.currentDetailsBrowse, mainSelectedBrowseId: (getMainSelectedBrowse() || {}).id };
        }

        function rowClick(browseName, browseCell)
        {
            var browse = getBrowseByName(browseName);
            if (browse === undefined)
            {
                return;
            }

            var row = browseCell.closest(classNames.browseRow.dot());
            var alreadyMainSelectedRow = row.hasClass(classNames.current) && browse.browse.hasClass(classNames.mainSelectedBrowse);

            if (alreadyMainSelectedRow)
            {
                return;
            }
            var data = browseCell.data();
            rowChange(browseName, data.row, browse.currentRow != data.row);
        }

        function changeSort()
        {
            var clickedElement = $(this);
            var browseData = clickedElement.data();
            if (browseData == null)
            {
                return;
            }

            var browse = skyward.browse.getContainingBrowse(this);
            if (!browse)
            {
                return;
            }

            var data = skyward.browse.getRequiredBrowseData(browse, browseData);
            data.sortField = browseData.sortField;
            data.sortAction = skyward.keys.globalShiftPressed ? "add" : "set";
            if (browseData.sortDescending == null)
            {
                data.descending = false;
            }
            else
            {
                data.descending = !browseData.sortDescending;
            }

            data.seekId = -1;

            data.browseViewSortChange = true;

            requestBrowse(browse.id, browse, data, "ChangeBrowseSort");
        }

        /**
         * @param {ClassicBrowse} browse
         */
        function addBrowseControlsClickEvents(browse)
        {
            browse.controls.on("click", ".js-addDashboardTile", function ()
            {
                addTileListener(browse);
            });
        }

        /**
         * @param {ClassicBrowse} browse
         */
        function addTileListener(browse)
        {
            const tileAddedEvent = 'WorkflowCompleted.SkySys.DashboardItem.DashboardItemConfigurationWorkflow';
            const body = $(document.body);
            body.one(tileAddedEvent, function ()
            {
                showTileConfirmationMessage(browse.contentMessageArea);
            });
        }

        /**
         * @param {ContentMessageAreaInstance} contentMessageArea
         */
        function showTileConfirmationMessage(contentMessageArea)
        {
            if (contentMessageArea)
            {
                contentMessageArea.setConfirmationMessage("Your tile has been successfully added to your dashboard!");
                contentMessageArea.showConfirmation();
            }
        }

        function addBrowseBodyClickEvents(browseData)
        {
            browseData.body.on("click", ".viewAndFilter.reset", function ()
            {
                const data = $(this).data();
                skyward.browse.resetViewAndFilter(data.browseViewId, data.browseFilterId, data.browseName);
            });

            if (browseData.selectMode)
            {
                browseData.body.on("click", ".js-selectRecord", function ()
                {
                    selectRecord(browseData.id, $(this).data("select-id"));
                });
            }
        }

        function addColumnHeaderClickEvents(browseData)
        {
            if (skyward.global.mobileAccess)
            {
                return;
            }
            browseData.header.on("click", ".browseColumnFilterMenuLaunch", browseHeaderColumnClick);
            browseData.header.on("click", ".browseColumnHeaderSort", changeSort);

            if (browseData.renderSortableHeader !== false)
            {
                browseData.header.on("click", ".browseColumnSortSpan", changeSort);
            }
        }

        function addPagingButtonClickEvents(browseName)
        {
            var footers = $("#" + browseName + "_footer");
            footers.on("click", ".pagingButton:not(.pagingButtonDisabled)", skyward.browse.changePage);
        }

        function totalRecordsButtonClicked()
        {
            var totalRecordsButton = $(this);

            if (totalRecordsButton.hasClass("totalRecordsButtonDisabled"))
            {
                return;
            }

            var browse = getBrowseByName(totalRecordsButton.parents(classNames.browse.dot())[0].id);
            if (browse === undefined)
            {
                return;
            }

            var menuContent = [{ type: "title", text: "Total Records" }];

            var recordCount = function ()
            {
                var content = $("<div class='customMenuPopupItem totalRecordsCount' aria-live='polite'>" + skyward.window.getImageHtml("getRecordCountPageLoadingGif") + "Loading Total Records</div>");
                var data = skyward.browse.getRequiredBrowseData(browse, totalRecordsButton.closest(classNames.browse.dot()).data());

                getBrowseRowCount(browse, data).done(function (recordCount)
                {
                    content.html(recordCount + " " + "Total Record".pluralize("Total Records", recordCount));
                });

                return content;
            };

            var recordCountContent =
            {
                type: "custom",
                content: recordCount
            };
            menuContent.push(recordCountContent);

            totalRecordsButton.addClass("totalRecordsButtonDisabled");
            skyward.modalLayer.showMenu(menuContent, totalRecordsButton, { beforeClose: function () { totalRecordsButton.focus(); totalRecordsButton.removeClass("totalRecordsButtonDisabled"); } });
        }

        function addTotalRecordsClickEvents(browseName)
        {
            var footers = $("#" + browseName + "_footer");
            footers.on("click", ".totalRecordsButton", totalRecordsButtonClicked);
        }

        function addColumnHeaderResizeEvents(browse, browseName)
        {
            if (skyward.global.mobileAccess)
            {
                return;
            }
            var browseId = browse.attr("id");

            // Used to batch up resizable columns
            var resizeDivs = [];

            browse.find(".tdResizeDiv").each(function ()
            {
                var element = $(this);
                var data = element.data();
                var columnIndex = data.column;
                var updateBrowseView = data.updateBrowseView;
                var resizable = { minWidth: skyward.browse.minColumnWidth, maxWidth: skyward.browse.maxColumnWidth, handles: "e" };

                if (element.hasClass("locked"))
                {
                    resizable.resize = function (_event, ui)
                    {
                        var unlockedElement = browse.find("#" + browseName + "_unlockedHeaderColumn_" + columnIndex);
                        unlockedElement.css("width", ui.size.width);
                    };
                    resizable.stop = function (_event, ui)
                    {
                        applyResize(updateBrowseView, columnIndex, ui.size.width, true);
                    };
                }
                else
                {
                    resizable.stop = function (_event, ui)
                    {
                        applyResize(updateBrowseView, columnIndex, ui.size.width, false);
                    };
                }
                resizeDivs.push({ element: element, resizable: resizable });
            });

            for (var index = 0; index < resizeDivs.length; index++)
            {
                var item = resizeDivs[index];
                item.element.resizable(item.resizable);
            }

            function applyResize(updateBrowseView, headerIndex, columnWidth, isLockedColumn)
            {
                var browse = getBrowseByName(browseName);
                if (!browse)
                {
                    return;
                }
                if (headerIndex != null)
                {
                    var resizeChildren = "#" + browseName + " .browseDataCell.column" + headerIndex;
                    $(resizeChildren).each(function ()
                    {
                        var dataCell = $(this);
                        var columnIndex = dataCell.attr("data-column");
                        if (columnIndex != null && columnIndex == headerIndex)
                        {
                            dataCell.children().css("width", columnWidth);
                        }
                    });

                    if (browse.totals.container.length)
                    {
                        var totalColumns = browse.totals.container.find(".browseFooter__totalColumn");
                        var updatedElement = totalColumns.filter("[data-column='" + headerIndex + "']");
                        if (isLockedColumn)
                        {
                            var initialLeft = parseFloat(updatedElement[0].style.left) + columnWidth;
                            var followingElements = totalColumns.slice(totalColumns.index(updatedElement) + 1);
                            updateTotalColumnOffsets(followingElements, initialLeft);
                        }
                        updatedElement.css("width", columnWidth);
                    }
                }

                if (isLockedColumn)
                {
                    resizeDataLockedBody();
                }

                browseResize(browseId);

                var currentbrowse = getBrowseByName(browseId);

                if (updateBrowseView && currentbrowse)
                {
                    var data =
                    {
                        columnIndex: headerIndex,
                        columnWidth: columnWidth,
                        fieldName: currentbrowse.browse.find(`[data-column-index=${headerIndex}]`).data("fieldName")
                    };

                    var url;
                    if (currentbrowse.data.browseViewEditorHash)
                    {
                        url = skyward.global.virtualDir + "SkySys/BrowseView/ResizeBrowseViewEditorColumn";
                        data.postData = JSON.stringify(currentbrowse.data);
                    }
                    else
                    {
                        url = skyward.global.virtualDir + "SkySys/BrowseView/ResizeColumn";
                        data.pageModule = currentbrowse.pageModule;
                        data.pageObject = currentbrowse.pageObject;
                        data.pageScreen = currentbrowse.pageScreen;
                        data.browseName = currentbrowse.browseName.replace("detailsPanel_", "");
                        data.taskName = currentbrowse.taskName;
                        data.browseId = currentbrowse.browseId;
                    }

                    $.ajax(
                        {
                            url: url,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            activityIndicator: { hideGlass: true },
                            success: function (data)
                            {
                                if (data && data.success)
                                {
                                    if (data.browseViewID && data.browseViewName)
                                    {
                                        currentbrowse.viewId = data.browseViewID;
                                        $("#" + browseId + "_viewButton .buttonSelectedValueLabel ").text(data.browseViewName);
                                    }
                                }
                            }
                        });
                }
            }

            function resizeDataLockedBody()
            {
                var shadowWidth = 13;
                var total = shadowWidth;
                $("#" + browseName + " .lockedBrowseBody tr:first-child td").each(function ()
                {
                    total += $(this).width();
                });
                var lockedBrowseBody = $("#" + browseName + " .lockedBrowseBody");
                var scrollWrapper = lockedBrowseBody.parent();
                var scrollbarWidth = lockedBrowseBody.width() - scrollWrapper.width();
                lockedBrowseBody.css("width", total + scrollbarWidth);
                scrollWrapper.css("width", total);
            }
        }

        function selectRecord(browseId, id)
        {
            const browse = getBrowseByName(browseId);
            if (browse !== undefined)
            {
                eventCallbacks.recordSelectionMade.dispatchCallbacks({ browseId: browseId, selectedId: id });
            }
            skyward.window.closePopup();
        };

        function finishRegistration(browseName)
        {
            var browse = getBrowseByName(browseName);
            if (browse === undefined)
            {
                return;
            }

            var debounceResize = skyward.debounce(function ()
            {
                browseResize(browseName);
            }, 50);

            $(window).resize(); // Triggers modallayer.positionEELContents()            
            debounceResize(browseName);

            // must be after resize() so our detailsPanel.eventCallbacks.resizeCanOpen callback doesn't run and open the details panel twice
            browse.isRegistered = true;

            if (browse.totals.container.length)
            {
                displayBrowseTotals(browse);
            }

            if (browse.currentRow != null)
            {
                skyward.browse.setCurrentRecord(browseName, browse.currentRow);
            }
            else if (browse.relatedBrowse)
            {
                var relatedBrowse = getBrowseByName(browse.relatedBrowse);
                if (relatedBrowse && relatedBrowse.body)
                {
                    relatedBrowse.body.empty();
                }
            }

            browse.browse.trigger("browseLoaded." + browseName);

            if (browse.isInDetailsPanel || browse.detailsPanelType === browseDetailsPanel.detailsPanelTypes.row && !(browse.rowModule && browse.rowObject && browse.rowScreen))
            {
                $("#" + browseName + "_previewDetails").remove();
            }
            else
            {
                browseDetailsPanel.tryRefreshDetailsPanel(browseName);
            }
        }

        function getBrowseByName(browseName)
        {
            return skyward.browse.browseList[browseName];
        }

        function getCurrentBrowse()
        {
            var browseName = skyward.browse.getCurrentBrowseName();
            return getBrowseByName(browseName);
        }

        function getLockedRowElement(browse, rowOverride)
        {
            return skyward.browse.getCurrentRowElement("locked", browse.id, rowOverride !== undefined ? rowOverride : browse.currentRow, browse.browseType);
        }

        function getUnlockedRowElement(browse, rowOverride)
        {
            return skyward.browse.getCurrentRowElement("unlocked", browse.id, rowOverride !== undefined ? rowOverride : browse.currentRow, browse.browseType);
        }

        function getRowElements(browse, rowOverride)
        {
            return getLockedRowElement(browse, rowOverride).add(getUnlockedRowElement(browse, rowOverride));
        }

        function keyDown(event)
        {
            var browse = getCurrentBrowse();

            if (!browse || !browse.keyEventsEnabled || skyward.browse.shouldIgnoreKeyboardEvent(document.activeElement))
            {
                return;
            }

            var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
            var selectPreviousRow = eventKeys.ARROW_UP;
            var selectNextRow = eventKeys.ARROW_DOWN;

            if (browse.selectMode && (selectPreviousRow || selectNextRow))
            {
                const layer = skyward.modalLayer.getLayerFromElement(browse.browse);
                if (layer)
                {
                    $(layer.originalActiveElement).focus();
                }
            }

            if (browse.browseType === "Tile")
            {
                selectPreviousRow = selectPreviousRow || eventKeys.ARROW_LEFT;
                selectNextRow = selectNextRow || eventKeys.ARROW_RIGHT;
            }

            if (selectPreviousRow || selectNextRow)
            {
                if (browse)
                {
                    var newRowNumber;

                    if (selectNextRow)
                    {
                        if (browse.currentRow == null)
                        {
                            event.preventDefault();
                            return;
                        }

                        if (browse.currentRow < browse.recordCount - 1)
                        {
                            newRowNumber = browse.currentRow + 1;
                        }
                        else if (browse.browseType === "DistinctMultiSelect" && browse.currentRow === browse.recordCount - 1)
                        {
                            newRowNumber = -1;
                        }
                        else
                        {
                            newRowNumber = 0;
                        }
                    }
                    else if (selectPreviousRow)
                    {
                        if (browse.currentRow == null)
                        {
                            event.preventDefault();
                            return;
                        }
                        if (browse.currentRow > 0)
                        {
                            newRowNumber = browse.currentRow - 1;
                        }
                        else if (browse.browseType === "DistinctMultiSelect" && browse.currentRow === 0)
                        {
                            newRowNumber = -1;
                        }
                        else
                        {
                            newRowNumber = browse.recordCount - 1;
                        }
                    }

                    if (browse.currentRow !== newRowNumber)
                    {
                        changeRow(browse.id, browse, newRowNumber);
                    }

                    addKeyUpHandler(event.which, browse.id);

                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }
            }
            else if (eventKeys.ENTER)
            {
                if (browse.browseType !== "DistinctMultiSelect")
                {
                    // ToDo: this function's current state is causing undesired key behavior, which has to be overriden with the below 'if' check on a browseExpandCollapseButton.
                    // Otherwise an enter on this button will instead select the browse's first row's primary button
                    var activeElement = $(document.activeElement);
                    if (activeElement.hasClass("browseExpandCollapseButton"))
                    {
                        return true;
                    }
                    else if (activeElement.length > 0 && ["A", "BUTTON"].indexOf(activeElement[0].nodeName) > -1)
                    {
                        document.activeElement.click();
                    }
                    else
                    {
                        if (browse.selectMode)
                        {
                            if ($(browse.body).find(classNames.current.dot()).first().length > 0)
                            {
                                selectRecord(browse.id, browse.primaryKeys[browse.currentRow]);
                            }
                        }
                        else
                        {
                            var currentRow = getUnlockedRowElement(browse);
                            var targetId = currentRow.data("targetid");
                            if (browse.primaryKeys[browse.currentRow] !== targetId)
                            {
                                var defaultRowMenuButton;
                                if (browse.browseType === "Tile")
                                {
                                    defaultRowMenuButton = currentRow;
                                }
                                else
                                {
                                    defaultRowMenuButton = currentRow.find("td.browseRowOptions div a.button").first();
                                }
                                if (defaultRowMenuButton.length > 0)
                                { // Simulate click on Default RowAction.  Not all point to a details screen, or the same Module/Object of the Browse.  Accounts for "Select" of EEL's, if/when
                                    defaultRowMenuButton[0].click();
                                }
                            }
                        }
                    }
                }

                event.preventDefault();
                event.stopPropagation();
                return false;
            }
        }

        function rowChange(browseName, row, loadRelatedBrowses)
        {
            browseDetailsPanel.tryRowChange(browseName, doRowChange, true);

            function doRowChange()
            {
                skyward.browse.setCurrentRecord(browseName, row, { setCurrentBrowseName: true, loadRelatedBrowses: loadRelatedBrowses });
            }
        }

        function repositionMoreMenu()
        {
            var browsesOnScreen = Object.keys(allBrowseStats);
            for (var i = 0; i < browsesOnScreen.length; i++)
            {
                var moreButton = $("#" + browsesOnScreen[i] + "_moreButton");
                var popupMenu = $("#" + browsesOnScreen[i] + "MenuPopup");
                var offset = moreButton.offset();
                if (offset)
                {
                    offset.top += moreButton.outerHeight();
                    offset.left = offset.left + moreButton.outerWidth(true) - popupMenu.outerWidth(true) - 2; //the 2 pixel difference is to account for padding on browses not covered in outerWidth

                    popupMenu.offset({ left: offset.left, top: offset.top });
                }
            }
        }

        function init(selector)
        {
            var selectorElement = $(selector);
            var browseElem = selectorElement.find(classNames.browse.dot()).add(selectorElement.filter(classNames.browse.dot()));
            if (browseElem.length)
            {
                // On DOM load, bind simulated-focus-handler to any newly loaded browses
                skyward.browse.bindLockedBodySimulatedFocus(browseElem);

                browseElem.each(function ()
                {
                    var browse = getBrowseByName(this.id);
                    if (browse === undefined)
                    {
                        return;
                    }
                    if (browse.isRegistered === false)
                    {
                        finishRegistration(this.id);
                    }
                });
            }

            // Customization
            selectorElement.find(".js-custombrowse").each(function initializeCustomBrowse()
            {
                var browse = $(this);
                var browseName = browse.data("browseName");
                var defaults =
                {
                    "browseType": "default",
                    "id": browseName,
                    "refreshTimeout": -1,
                    "keyEventsEnabled": true
                };
                if (browse.data("isSimpleBrowse"))
                {
                    // based on SimpleBrowse.cs
                    $.extend(defaults,
                        {
                            preventColumnSort: true,
                            preventColumnResize: true,
                            hidePreviewDetailsButton: true,
                            hideBrowseControl: true,
                            renderSearchBox: false,
                            renderViewButton: false,
                            renderFilterButton: false,
                            renderHeaderSettings: false,
                            renderSortableHeader: false,
                            renderRowsPerPageOption: false,
                        });
                }

                skyward.browse.browseList[browseName] = Object.assign({}, defaults, browse.data(), { isSimpleBrowse: undefined });
                skyward.browse.openBrowses.unshift(browseName);
                skyward.browse.get(browseName, {});
            });
        }

        function initialize()
        {
            skyward.window.registerLoadDOMCallback(init);
            skyward.window.registerLoadDOMCallback(initActiveBrowseClass);
            skyward.window.registerBrowseResizeCallback(skyward.browse.resizeBrowseList);
            skyward.window.registerLayoutResizeCallback(repositionMoreMenu);

            if (!skyward.global.mobileAccess)
            {
                skyward.window.registerLoadDOMCallback(initSortableColumns);
            }

            // Event handlers
            var events =
            {
                getBrowseExport: exportBrowse,
                designReport: designReport,
                showAuditLegend: showAuditLegend,
                browseLinkColumnPopup: skyward.browse.browseLinkColumnPopup,
                forceToggleDetailsPanel: function ()
                {
                    var button = $(this);
                    var browseId = button.attr("data-browse-id");
                    browseDetailsPanel.toggleDetailsPanel(browseId, true);
                }
            };

            skyward.events.registerEvents("browse", events);

            skyward.error.registerErrorDataGatherer("browse", gatherDataForError);

            browseDetailsPanel.init();

            $(document.documentElement).on("keydown", keyDown);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);